const sl = {
  'common.loading': 'Nalaganje …',
  'common.save': 'Shrani',
  'common.cancel': 'Prekliči',
  'common.delete': 'Izbriši',
  'common.search': 'Išči',
  'common.accessDenied': 'Dostop zavrnjen',
  'common.backToLogin': 'Nazaj na prijavo',
  'common.markAsRead': 'Označi kot prebrano',
  'shell.supportDesk': 'Center za podporo',
  'shell.searchPlaceholder': 'Išči zahtevke, stike, članke …',
  'shell.newTicket': 'Nov zahtevek',
  'shell.notifications': 'Obvestila',
  'shell.notificationPreferences': 'Nastavitve obvestil',
  'shell.settings': 'Nastavitve',
  'shell.signOut': 'Odjava',
  'shell.expandNavigation': 'Razširi navigacijo',
  'shell.collapseNavigation': 'Strni navigacijo',
  'shell.caughtUp': 'Vse je pregledano',
  'shell.viewAllNotifications': 'Prikaži vsa obvestila',
  'nav.dashboard': 'Nadzorna plošča',
  'nav.tickets': 'Zahtevki',
  'nav.contacts': 'Stiki',
  'nav.companies': 'Podjetja',
  'nav.reports': 'Poročila',
  'nav.settings': 'Nastavitve',
  'nav.agents': 'Agenti',
  'nav.groups': 'Skupine',
  'nav.roles': 'Vloge',
  'nav.tags': 'Oznake',
  'nav.ticketFields': 'Polja zahtevka',
  'nav.ticketForms': 'Obrazci zahtevkov',
  'nav.businessHours': 'Delovni čas',
  'nav.slaPolicies': 'Pravila SLA',
  'nav.automations': 'Avtomatizacije',
  'nav.email': 'E-pošta',
  'nav.notificationTemplates': 'Predloge obvestil',
  'nav.apiKeys': 'Ključi API',
  'nav.cannedResponses': 'Pripravljeni odgovori',
  'nav.knowledgeBase': 'Zbirka znanja',
  'auth.signInTitle': 'Center za podporo SDPL',
  'auth.signInSubtitle': 'Prijavite se v svoj račun',
  'auth.emailAddress': 'E-poštni naslov',
  'auth.password': 'Geslo',
  'auth.signingIn': 'Prijavljanje …',
  'auth.signIn': 'Prijava',
  'auth.forgotPassword': 'Ste pozabili geslo?',
  'auth.twoFactor': 'Dvostopenjsko preverjanje pristnosti',
  'auth.verificationCode': 'Verifikacijska koda',
  'auth.verify': 'Preveri',
  'auth.backToLogin': 'Nazaj na prijavo',
  'agents.title': 'Agenti',
  'agents.new': 'Nov agent',
  'agents.supportAgents': 'Agenti podpore',
  'agents.collaborators': 'Sodelavci',
  'agents.deactivated': 'Deaktivirani',
  'agents.searchPlaceholder': 'Išči po imenu ali e-pošti',
  'agents.edit': 'Uredi',
  'agents.deactivate': 'Deaktiviraj',
  'agents.reactivate': 'Ponovno aktiviraj',
  'agents.saved': 'Agent je shranjen.',
  'agents.firstName': 'Ime',
  'agents.lastName': 'Priimek',
  'agents.email': 'E-pošta',
  'agents.phone': 'Telefon',
  'agents.timezone': 'Časovni pas',
  'agents.selectTimezone': 'Izberite časovni pas',
  'agents.language': 'Jezik',
  'agents.selectLanguage': 'Izberite jezik',
  'agents.emailSignature': 'E-poštni podpis',
  'agents.roleRequired': 'Vloga',
  'agents.selectRole': 'Izberite vlogo',
  'agents.status': 'Stanje',
  'agents.groupsTitle': 'Skupine',
  'agents.manageGroups': 'Upravljaj skupine',
  'agents.notInGroup': 'Še ni v skupini',
  'dashboard.title': 'Nadzorna plošča',
  'dashboard.description': 'Trenutna delovna obremenitev podpore in stanje storitve.',
  'dashboard.allGroups': 'Vse dostopne skupine',
  'dashboard.unresolved': 'Nerešeni',
  'dashboard.overdue': 'Zapadli',
  'dashboard.dueToday': 'Zapade danes',
  'dashboard.open': 'Odprti',
  'dashboard.onHold': 'Na čakanju',
  'dashboard.unassigned': 'Nedodeljeni',
  'dashboard.trends': 'Današnji trendi',
  'notifications.title': 'Obvestila',
  'notifications.description': 'Celotna zgodovina vaših obvestil.',
  'notifications.markAllRead': 'Označi vse kot prebrano',
  'notifications.filter': 'Filter',
  'notifications.allTypes': 'Vse vrste',
  'notifications.none': 'Obvestil še ni',
  'notifications.assigned': 'Dodeljeno',
  'notifications.reply': 'Odgovor',
  'notifications.note': 'Opomba',
  'notifications.slaWarning': 'Opozorilo SLA',
  'notifications.slaBreach': 'Kršitev SLA',
  'notifications.slaEscalation': 'Eskalacija SLA',
  'notifications.mention': 'Omemba',
  'preferences.title': 'Nastavitve obvestil',
  'preferences.description': 'Obvestila v aplikaciji so vedno vklopljena. Izberite, katera naj pošljejo tudi e-pošto.',
  'preferences.emailDigest': 'Povzetek po e-pošti',
  'preferences.dailySummary': 'Prejmite en dnevni povzetek namesto e-pošte za vsak dogodek.',
  'preferences.digestOff': 'Izklopljeno — e-pošta za vsak dogodek',
  'preferences.digestDaily': 'Dnevni povzetek',
  'preferences.emailNotifications': 'E-poštna obvestila',
  'activities.button': 'Nedavne dejavnosti',
  'activities.title': 'Nedavne dejavnosti',
  'activities.loadError': 'Nedavnih dejavnosti ni bilo mogoče naložiti.',
  'activities.systemActor': 'Sistem',
  'activities.noneTitle': 'Še ni nedavnih dejavnosti',
  'activities.noneDescription': 'Posodobitve zahtevkov od vas in vaše skupine se bodo prikazale tukaj, ko se zgodijo.',
  'tickets.title': 'Zahtevki',
  'tickets.description': 'Vsi zahtevki, do katerih imate dostop, filtrirani in razvrščeni po vaših potrebah.',
  'tickets.dueDateTabs': 'Rok zahtevka',
  'tickets.tabAll': 'Vsi zahtevki',
  'tickets.tabDueToday': 'Rok danes',
  'tickets.tabOverdue': 'Zapadlo',
  'tickets.tabDueTomorrow': 'Rok jutri',
  'tickets.searchPlaceholder': 'Iskanje zahtevkov…',
  'tickets.searchAria': 'Iskanje zahtevkov',
  'tickets.filters': 'Filtri',
  'tickets.filtersWithCount': 'Filtri ({count})',
  'tickets.sortAria': 'Razvrsti zahtevke po',
  'tickets.sortTrigger': 'Razvrsti: {label}',
  'tickets.sortDateCreated': 'Datum nastanka',
  'tickets.sortDateUpdated': 'Datum posodobitve',
  'tickets.sortPriority': 'Prioriteta',
  'tickets.sortStatus': 'Stanje',
  'tickets.sortDueDate': 'Rok',
  'tickets.sortAscending': 'Razvrsti naraščajoče',
  'tickets.sortDescending': 'Razvrsti padajoče',
  'tickets.ascending': 'Naraščajoče',
  'tickets.descending': 'Padajoče',
  'tickets.layoutAria': 'Postavitev vrstic',
  'tickets.layoutTrigger': 'Postavitev: {label}',
  'tickets.layoutCard': 'Kartica',
  'tickets.layoutInbox': 'Prejeta pošta',
  'tickets.layoutTable': 'Tabela',
  'tickets.export': 'Izvoz',
  'tickets.exportSelected': 'Izvozi izbrano',
  'tickets.selectedCount': 'Izbranih: {count}',
  'tickets.assignAgent': 'Dodeli agenta',
  'tickets.closeAll': 'Zapri vse',
  'tickets.clearSelection': 'Počisti izbor',
  'tickets.selectAgentPlaceholder': 'Izberite agenta...',
  'tickets.assignTo': 'Dodeli osebi',
  'tickets.assign': 'Dodeli',
  'tickets.loadFailed': 'Zahtevkov ni bilo mogoče naložiti. Poskusite znova.',
  'tickets.bulkCloseFailed': 'Izbranih zahtevkov ni bilo mogoče zapreti. Poskusite znova.',
  'tickets.bulkAssignFailed': 'Izbranih zahtevkov ni bilo mogoče dodeliti. Poskusite znova.',
  'tickets.noFilterMatchTitle': 'Noben zahtevek ne ustreza tem filtrom',
  'tickets.noFilterMatchDescription': 'Poskusite odstraniti filter, razširiti časovno obdobje ali iskati drug izraz.',
  'tickets.clearFilters': 'Počisti filtre',
  'tickets.queueClearTitle': 'Ta čakalna vrsta je prazna',
  'tickets.queueClearDescription': 'Novi zahtevki se bodo tukaj prikazali, ko stranka pošlje e-pošto, uporabi portal ali ga ustvari agent.',
  'tickets.newTicket': 'Nov zahtevek',
  'tickets.selectAllAria': 'Izberi vse zahtevke',
  'tickets.selectTicketAria': 'Izberi zahtevek št. {number}',
  'tickets.columnContact': 'Stik',
  'tickets.columnSubject': 'Zadeva',
  'tickets.columnState': 'Stanje',
  'tickets.columnGroup': 'Skupina',
  'tickets.columnAgent': 'Agent',
  'tickets.columnPriority': 'Prioriteta',
  'tickets.noGroup': 'Brez skupine',
  'tickets.unassigned': 'Ni dodeljeno',
  'tickets.createdRelative': 'Ustvarjeno {when}',
  'tickets.unassignedOnly': 'Samo nedodeljene',
  'tickets.unknownRequester': 'Neznan prosilec',
  'tickets.overdueBy': 'Zapadlo za {duration}',
  'tickets.dueIn': 'Rok čez {duration}',
  'tickets.filtersDrawerTitle': 'Filtri',
  'tickets.filtersSearchPlaceholder': 'Iskanje polj',
  'tickets.filtersSearchAria': 'Iskanje polj filtra',
  'tickets.filtersClearAll': 'Počisti vse',
  'tickets.filtersApply': 'Uporabi',
  'tickets.filterAgents': 'Agenti',
  'tickets.filterAnyAgent': 'Kateri koli agent',
  'tickets.filterGroups': 'Skupine',
  'tickets.filterAnyGroup': 'Katera koli skupina',
  'tickets.filterStatus': 'Stanje',
  'tickets.filterAnyStatus': 'Katero koli stanje',
  'tickets.filterPriority': 'Prioriteta',
  'tickets.filterAnyPriority': 'Katera koli prioriteta',
  'tickets.filterSource': 'Vir',
  'tickets.filterAnySource': 'Kateri koli vir',
  'tickets.filterTicketType': 'Vrsta zahtevka',
  'tickets.filterAnyType': 'Katera koli vrsta',
  'tickets.filterTags': 'Oznake',
  'tickets.filterAnyTag': 'Katera koli oznaka',
  'tickets.filterCompanies': 'Podjetja',
  'tickets.filterAnyCompany': 'Katero koli podjetje',
  'tickets.filterCreated': 'Ustvarjeno',
  'tickets.filterResolvedAt': 'Rešeno',
  'tickets.filterClosedAt': 'Zaprto',
  'tickets.filterDateFrom': '{label} od',
  'tickets.filterDateTo': '{label} do',
  'tickets.filterDateTo2': 'do',
  'tickets.filterAny': 'Katero koli',
  'tickets.chipFieldStatus': 'Stanje',
  'tickets.chipFieldPriority': 'Prioriteta',
  'tickets.chipFieldGroup': 'Skupina',
  'tickets.chipFieldAssignee': 'Odgovorna oseba',
  'tickets.chipValueGroup': 'Skupina',
  'tickets.chipValueUnassigned': 'Ni dodeljeno',
  'common.saving': 'Shranjevanje …',
  'common.clearSearch': 'Počisti iskanje',
  'common.sortBy': 'Razvrsti po',
  'common.name': 'Ime',
  'common.role': 'Vloga',
  'common.groups': 'Skupine',
  'common.tickets': 'Zahtevki',
  'common.lastSeen': 'Nazadnje viden',
  'common.actions': 'Dejanja',
  'common.never': 'Nikoli',
  'common.justNow': 'Pravkar',
  'common.minutesAgo': 'pred {count} min',
  'common.hoursAgo': 'pred {count} h',
  'common.daysAgo': 'pred {count} d',
  'common.noPagePermission': 'Nimate dovoljenja za dostop do te strani.',
  'common.roleNoPermission': 'Vaša vloga nima dovoljenja za dostop do te strani.',
  'common.requestFailed': 'Zahteva ni uspela. Poskusite znova.',
  'common.unexpectedError': 'Prišlo je do nepričakovane napake',
  'common.user': 'Uporabnik',
  'shell.skipToMain': 'Preskoči na glavno vsebino',
  'shell.homeLabel': 'Domača stran Suzuki Support Desk',
  'shell.userMenu': 'Uporabniški meni',
  'shell.unread': '{count} neprebranih',
  'shell.adminNavigation': 'Skrbniška navigacija',
  'shell.notificationDescription': 'Nove dodelitve, odgovori in opozorila SLA se bodo prikazale tukaj.',
  'auth.enterAuthenticatorCode': 'Vnesite 6-mestno kodo iz aplikacije za preverjanje pristnosti',
  'auth.verifying': 'Preverjanje …',
  'auth.setupAuthenticator': 'Nastavi aplikacijo za preverjanje pristnosti',
  'auth.scanAuthenticator': 'Skenirajte to kodo z aplikacijo za preverjanje pristnosti (Google Authenticator, Authy itd.)',
  'auth.authenticatorSetupQr': 'QR koda za nastavitev aplikacije za preverjanje pristnosti',
  'auth.verificationCodeFromAuthenticator': 'Verifikacijska koda iz aplikacije za preverjanje pristnosti',
  'auth.verifyAndComplete': 'Preveri in dokončaj nastavitev',
  'auth.loadingSetup': 'Nalaganje nastavitve …',
  'auth.setNewPassword': 'Nastavi novo geslo',
  'auth.temporaryPasswordExpired': 'Vaše začasno geslo je poteklo. Nastavite novo geslo.',
  'auth.newPassword': 'Novo geslo',
  'auth.confirmPassword': 'Potrdite geslo',
  'auth.settingPassword': 'Nastavljanje gesla …',
  'auth.setPassword': 'Nastavi geslo',
  'auth.passwordRequirements': 'Potrebnih je vsaj 8 znakov, velika in mala črka, številka in simbol',
  'auth.tooManyAttempts': 'Preveč poskusov prijave. Poskusite znova pozneje.',
  'auth.invalidCredentials': 'Neveljaven e-poštni naslov ali geslo',
  'auth.passwordsDoNotMatch': 'Gesli se ne ujemata',
  'auth.passwordMinimum': 'Geslo mora imeti vsaj {count} znakov',
  'auth.resetTitle': 'Ponastavite geslo',
  'auth.resetSubtitle': 'Vnesite svoj e-poštni naslov in poslali vam bomo povezavo za ponastavitev',
  'auth.checkEmail': 'Preverite e-pošto za povezavo za ponastavitev',
  'auth.checkCode': 'Preverite e-pošto za verifikacijsko kodo in nato nadaljujte spodaj.',
  'auth.continueToReset': 'Nadaljujte s ponastavitvijo gesla',
  'auth.sendResetLink': 'Poslji povezavo za ponastavitev',
  'auth.sending': 'Pošiljanje …',
  'auth.resetSuccess': 'Vaše geslo je bilo uspešno ponastavljeno.',
  'auth.goToLogin': 'Pojdi na prijavo',
  'auth.missingResetToken': 'Manjka žeton za ponastavitev. Uporabite povezavo iz e-pošte.',
  'auth.enterCodeFromEmail': 'Vnesite verifikacijsko kodo, poslano na vaš e-poštni naslov',
  'auth.codeFromEmail': 'Vnesite kodo iz e-pošte',
  'auth.emailRequired': 'E-poštni naslov je obvezen',
  'auth.codeRequired': 'Verifikacijska koda je obvezna',
  'auth.missingToken': 'Manjka žeton za ponastavitev',
  'auth.failedReset': 'Ponastavitev gesla ni uspela.',
  'auth.resetting': 'Ponastavljanje …',
  'auth.resetPassword': 'Ponastavi geslo',
  'auth.looksGood': 'Videti je v redu',
  'auth.needCharacters': 'Potrebnih je vsaj {count} znakov',
  'auth.passwordFormat': 'Potrebnih je vsaj {count} znakov, velika in mala črka, številka in simbol',
  'agents.description': 'Ljudje, ki obravnavajo zahtevke. Dodelite vlogo za nadzor, kaj lahko počnejo, in skupine za nadzor, kaj vidijo.',
  'agents.searchAria': 'Iskanje agentov',
  'agents.countOne': '{count} agent',
  'agents.countMany': '{count} agentov',
  'agents.ticketOne': '{count} zahtevek',
  'agents.ticketMany': '{count} zahtevkov',
  'agents.noGroups': 'Ni skupin',
  'agents.lifecycle': 'Življenjski cikel agenta',
  'agents.noSearchResults': 'Temu iskanju ne ustreza noben agent',
  'agents.noAgentsView': 'V tem prikazu ni agentov',
  'agents.tryDifferent': 'Poskusite z drugim imenom ali e-poštnim naslovom.',
  'agents.useNewAgent': 'Uporabite Nov agent za dodajanje osebe ali preklopite zavihek za ogled drugih agentov.',
  'agents.agent': 'Agent',
  'agents.noRole': 'Ni vloge',
  'agents.openTicketsTitle': 'Odprti zahtevki, trenutno dodeljeni temu agentu',
  'agents.moreActions': 'Več dejanj za {name}',
  'agents.confirmDeleteTitle': 'Izbrišete {name}?',
  'agents.confirmDeleteDescription': 'Tega ni mogoče razveljaviti. Agentov, povezanih z zahtevki, ni mogoče izbrisati; namesto tega jih deaktivirajte.',
  'agents.confirmDeleteLabel': 'Izbriši agenta',
  'agents.agentsVsCollaborators': 'Agenti proti sodelavcem',
  'agents.agentsVsCollaboratorsBody': 'Agenti podpore dnevno obravnavajo zahtevke. Sodelavci imajo vlogo sodelavca in so običajno strokovnjaki, vključeni pri posameznih zahtevkih brez popolnega dostopa agenta.',
  'agents.deactivateVsDelete': 'Deaktivacija proti brisanju',
  'agents.deactivateVsDeleteBody': 'Deaktivacija ohrani zgodovino in lastništvo zahtevkov, vendar blokira prijavo. Brisanje je dokončno in deluje samo, ko agent nima povezanih zahtevkov.',
  'agents.newTitle': 'Nov agent',
  'agents.editTitle': 'Uredi agenta',
  'agents.temporaryPassword': 'Začasno geslo',
  'agents.passwordHelp': 'Vsaj 12 znakov. Agent ga lahko spremeni po prijavi.',
  'agents.timezoneHelp': 'Vsak datum in čas, ki ga ta agent vidi, se prikaže v tem časovnem pasu.',
  'agents.languageHelp': 'Prevede vmesnik za agente. Odgovori na zahtevke in vsebina strank se ne prevajajo.',
  'agents.signaturePlaceholder': 'Dodano izhodnim odgovorom',
  'agents.roleHelp': 'Določa, kaj lahko ta agent počne.',
  'agents.manageRoles': 'Upravljanje vlog',
  'agents.activeHelp': 'Aktiven — odstranitev kljukice blokira prijavo brez brisanja agenta',
  'agents.groupHelp': 'Dodajte tega agenta v skupino na zaslonu Skupine za nadzor, katere zahtevke vidi.',
  'agents.about': 'O tem agentu',
  'agents.aboutBody': 'Ime, e-pošta, telefon, časovni pas, jezik in podpis identificirajo agenta ter personalizirajo njegov delovni prostor. Vloga nadzoruje, kaj lahko počne; članstvo v skupini nadzoruje, katere zahtevke vidi.',
  'dashboard.trendsDescription': 'Ustvarjanje zahtevkov po urah UTC, v primerjavi z včeraj.',
  'dashboard.today': 'Danes',
  'dashboard.yesterday': 'Včeraj',
  'dashboard.chartAria': 'Obseg zahtevkov po urah UTC, danes v primerjavi z včeraj',
  'dashboard.dataUnavailable': 'Podatki nadzorne plošče niso na voljo.',
  'dashboard.loadError': 'Podatkov nadzorne plošče ni mogoče naložiti. Poskusite znova.',
  'notifications.noType': 'Ni obvestil te vrste',
  'notifications.allTypesHint': 'Izberite »Vse vrste« zgoraj, da si ogledate preostanek zgodovine.',
  'notifications.emptyDescription': 'Dodelitve, odgovori in opozorila SLA se prikažejo tukaj. Prilagodite, katera od njih vam pošljejo tudi e-pošto v nastavitvah obvestil.',
  'preferences.digestWarning': 'Uporabljate dnevni povzetek, zato so te nastavitve prezrte, dokler ga ne izklopite.',
  'preferences.assignedEvent': 'Zahtevek vam je dodeljen',
  'preferences.replyEvent': 'Zahtevek, na katerem ste, prejme odgovor',
  'preferences.noteEvent': 'Dodana je zasebna opomba',
  'preferences.slaWarningEvent': 'SLA se približuje svojemu roku',
  'preferences.slaBreachEvent': 'SLA je kršen',
  'preferences.slaEscalationEvent': 'SLA eskalira po roku',
  'preferences.mentionEvent': 'Omenjeni ste v zahtevku',

  'ticketDetail.back': 'Nazaj',
  'ticketDetail.follow': 'Sledi',
  'ticketDetail.following': 'Sledite',
  'ticketDetail.hideActivities': 'Skrij dejavnosti',
  'ticketDetail.activitiesButton': 'Dejavnosti',
  'ticketDetail.attachmentsCount': 'Priloge ({count})',
  'ticketDetail.threadAria': 'Nit zahtevka',
  'ticketDetail.conversationsTabLabel': 'Pogovori',
  'ticketDetail.activitiesTabLabel': 'Dejavnosti',
  'ticketDetail.noRepliesYet': 'Še ni odgovorov',
  'ticketDetail.noRepliesDescription': 'Uporabite urejevalnik spodaj za odgovor prosilcu ali dodajanje interne opombe.',
  'ticketDetail.privateNote': 'Zasebna opomba',
  'ticketDetail.forward': 'Posredovano',
  'ticketDetail.uploadingAria': 'Nalaganje',
  'ticketDetail.uploadingProgress': 'Nalaganje {uploading} od {total} datotek …',
  'ticketDetail.uploadsFailed': '{count} nalaganj ni uspelo',
  'ticketDetail.retry': 'Poskusi znova',
  'ticketDetail.dismiss': 'Opusti',
  'ticketDetail.noActivityYet': 'Še ni dejavnosti',
  'ticketDetail.noActivityDescription': 'Spremembe stanja, agenta in SLA bodo prikazane tukaj, ko se zahtevek razvija.',
  'ticketDetail.requester': 'Prosilec',
  'ticketDetail.properties': 'Lastnosti',
  'ticketDetail.updating': 'Posodabljanje …',
  'ticketDetail.update': 'Posodobi',
  'ticketDetail.tags': 'Oznake',
  'ticketDetail.relationships': 'Povezave',
  'ticketDetail.parentTicket': 'Nadrejeni zahtevek',
  'ticketDetail.unlink': 'Odstrani povezavo',
  'ticketDetail.noParentTicket': 'Brez nadrejenega zahtevka',
  'ticketDetail.childTicketsCount': 'Podrejeni zahtevki ({count})',
  'ticketDetail.noChildTickets': 'Brez podrejenih zahtevkov',
  'ticketDetail.findTicket': 'Poišči zahtevek',
  'ticketDetail.ticketSearchPlaceholder': 'Številka zahtevka ali zadeva',
  'ticketDetail.searchButton': 'Iskanje',
  'ticketDetail.setParent': 'Nastavi kot nadrejeno',
  'ticketDetail.mergeIntoAction': 'Združi z',
  'ticketDetail.splitIntoChild': 'Razdeli v podrejeni zahtevek',
  'ticketDetail.newTicketSubjectPlaceholder': 'Zadeva novega zahtevka',
  'ticketDetail.splitButton': 'Razdeli',
  'ticketDetail.copyAttachments': 'Kopiraj priloge',
  'ticketDetail.copyConversationHistory': 'Kopiraj zgodovino pogovora',
  'ticketDetail.slaLabel': 'SLA',
  'ticketDetail.paused': 'Prekinjeno',
  'ticketDetail.editButton': 'Uredi',
  'ticketDetail.setResolutionDueDate': 'Nastavi rok za rešitev',
  'ticketDetail.pickDateTime': 'Izberi datum in čas',
  'ticketDetail.resolutionDueLabel': 'Rok za rešitev',
  'ticketDetail.saveSla': 'Shrani SLA',
  'ticketDetail.savingSla': 'Shranjevanje …',
  'ticketDetail.noSlaPolicy': 'Za ta zahtevek ni uveljavljeno nobeno pravilo SLA.',
  'ticketDetail.firstResponse': 'Prvi odgovor',
  'ticketDetail.resolution': 'Rešitev',
  'ticketDetail.done': 'Končano',
  'ticketDetail.pausedSince': 'Prekinjeno od {date}',
  'ticketDetail.escalation': 'Eskalacija',
  'ticketDetail.escalatedLevel2': 'Eskalirano (2. stopnja)',
  'ticketDetail.escalated': 'Eskalirano',
  'ticketDetail.dueDateOverridden': 'Rok je ročno spremenil skrbnik.',
  'ticketDetail.dates': 'Datumi',
  'ticketDetail.created': 'Ustvarjeno',
  'ticketDetail.updated': 'Posodobljeno',
  'ticketDetail.resolved': 'Rešeno',
  'ticketDetail.closed': 'Zaprto',
  'ticketDetail.loadErrorTitle': 'Tega zahtevka ni bilo mogoče naložiti',
  'ticketDetail.notFound': 'Zahtevek ni najden',
  'ticketDetail.confirmMergeTitle': 'Združite zahtevek št. {source} s št. {target}?',
  'ticketDetail.confirmMergeDescription': 'Trenutni zahtevek bo zaprt. Tega ni mogoče razveljaviti.',
  'ticketDetail.confirmMergeLabel': 'Združi zahtevek',
  'ticketDetail.updateSuccess': 'Zahtevek posodobljen',
  'ticketDetail.updateError': 'Zahtevka ni bilo mogoče posodobiti',
  'ticketDetail.pickDateTitle': 'Izberite datum',
  'ticketDetail.pickDateDescription': 'Izberite rok za rešitev.',
  'ticketDetail.slaUpdateSuccess': 'SLA posodobljen',
  'ticketDetail.slaUpdateError': 'SLA ni bilo mogoče posodobiti',
  'ticketDetail.searchError': 'Zahtevkov ni bilo mogoče iskati',
  'ticketDetail.parentUpdateError': 'Nadrejenega zahtevka ni bilo mogoče posodobiti',
  'ticketDetail.mergeSuccess': 'Združeno s št. {number}',
  'ticketDetail.mergeError': 'Zahtevka ni bilo mogoče združiti',
  'ticketDetail.splitSuccess': 'Delitev zahtevka ustvarjena',
  'ticketDetail.splitError': 'Zahtevka ni bilo mogoče razdeliti',
  'ticketDetail.downloadError': 'Priloge ni bilo mogoče prenesti',
  'ticketDetail.followSuccess': 'Zdaj sledite zahtevku',
  'ticketDetail.unfollowSuccess': 'Prenehali ste slediti zahtevku',
  'ticketDetail.watcherError': 'Stanja sledenja ni bilo mogoče posodobiti',
  'ticketDetail.fieldsLoadError': 'Polj zahtevka ni bilo mogoče naložiti',
  'ticketDetail.overdueBy': 'Zamuja {label}',
  'ticketDetail.dueLeft': 'Preostane {label}',
  'ticketDetail.presetToday': 'Danes',
  'ticketDetail.presetTomorrow': 'Jutri',
  'ticketDetail.presetThisWeek': 'Ta teden',
  'ticketDetail.presetNextWeek': 'Naslednji teden',
  'ticketDetail.presetThisMonth': 'Ta mesec',
  'ticketDetail.eventTicketCreated': 'Zahtevek ustvarjen',
  'ticketDetail.eventStatusUpdated': 'Stanje posodobljeno',
  'ticketDetail.eventAgentUpdated': 'Agent posodobljen',
  'ticketDetail.eventSlaUpdated': 'SLA posodobljen',
  'ticketDetail.eventTicketMerged': 'Zahtevek združen',
  'ticketDetail.eventMergeReceived': 'Združitev prejeta',
  'ticketDetail.eventTicketSplit': 'Zahtevek razdeljen',
  'ticketDetail.eventUpdated': 'Posodobljeno',
  'ticketDetail.eventSplitContentCopied': 'Razdeljena vsebina kopirana',
  'ticketDetail.eventReplySent': 'Odgovor poslan',
  'ticketDetail.eventNoteAdded': 'Opomba dodana',
  'ticketDetail.eventCustomerReplied': 'Stranka je odgovorila',
  'ticketDetail.eventTicketDeleted': 'Zahtevek izbrisan',
  'preferences.createdEvent': 'Zahtevek je ustvarjen',
  'preferences.pendingInputEvent': 'Zahtevek čaka na vaš odgovor',
  'preferences.resolvedEvent': 'Zahtevek je rešen',
  'agents.assignGroups': 'Dodeli skupine',
  'agents.assignGroupsHelp': 'Članstvo v skupinah določa, katere zahtevke lahko ta agent vidi.',
  'agents.selectGroups': 'Izberi skupine',
  'agents.ticketVisibility': 'Vidnost zahtevkov',
  'agents.ticketVisibilityHelp': 'Izberite ožjo omejitev za agenta ali podedujte privzeto nastavitev vloge. Dovoljenja vloge še vedno določajo, kaj lahko agent naredi.',
  'agents.scopeRoleDefault': 'Uporabi privzeto nastavitev vloge',
  'agents.scopeRoleDefaultHelp': 'Podeduj privzeto vidnost, nastavljeno za to vlogo.',
  'agents.scopeAll': 'Vsi zahtevki',
  'agents.scopeAllHelp': 'Prikaži vse neizbrisane zahtevke v tem računu.',
  'agents.scopeGroup': 'Zahtevki v skupini',
  'agents.scopeGroupHelp': 'Prikaži zahtevke, dodeljene skupinam, katerih član je agent.',
  'agents.scopeAssigned': 'Dodeljeni zahtevki',
  'agents.scopeAssignedHelp': 'Prikaži zahtevke, dodeljene neposredno temu agentu.',
  'agents.scopeCollaboratorHelp': 'Sodelavci ostajajo omejeni na zahtevke v svojih skupinah L1.',
  'nav.jira': 'Integracija Jira',
  'notifications.groupAssigned': 'Dodelitev skupini',
  'notifications.groupMemberAdded': 'Dodan v skupino',
  'preferences.groupAssignedEvent': 'Zahtevek je dodeljen eni od vaših skupin',
  'preferences.groupMemberAddedEvent': 'Dodani ste v skupino za podporo',
  'ui.select': 'Izberi…',
  'ui.any': 'Poljubno',
  'ui.typeToSearch': 'Vnesite za iskanje…',
  'ui.noResults': 'Ni najdenih rezultatov',
  'ui.clearSelection': 'Počisti izbiro',
  'ui.removeItem': 'Odstrani {label}',
  'ui.pressEnterToUse': 'Pritisnite Enter za uporabo te vrednosti',
  'ui.removeFilter': 'Odstrani filter {field}: {value}',
  'ui.removeTag': 'Odstrani oznako {label}',
  'ui.retry': 'Poskusi znova',
  'ui.errorTitle': 'Te vsebine ni bilo mogoče naložiti',
  'ui.errorMessage': 'Preverite povezavo in poskusite znova.',
  'ui.reference': 'Sklic: {id}',
  'ui.thisArea': 'to območje',
  'ui.noAccess': 'Nimate dostopa do območja {area}',
  'ui.noAccessHint': 'Prosite skrbnika, naj vam dodeli potrebno dovoljenje.',
  'ui.actionFailed': 'Dejanja ni bilo mogoče dokončati. Poskusite znova.',
  'ui.slaPaused': 'SLA zaustavljen',
  'ui.filteredEmptyTitle': 'Nobeden zahtevek ne ustreza tem filtrom',
  'ui.filteredEmptyDescription': 'Poskusite odstraniti filter ali razširiti časovno obdobje.',
  'ui.clearFilters': 'Počisti filtre',
  'pagination.noResults': 'Ni rezultatov',
  'pagination.showing': 'Prikazano {first}–{last} od {total}',
  'pagination.resultsPerPage': 'Rezultatov na stran',
  'pagination.perPage': '{count} na stran',
  'pagination.previous': 'Prejšnja',
  'pagination.next': 'Naslednja',
  'pagination.previousAria': 'Prejšnja stran',
  'pagination.nextAria': 'Naslednja stran',
  'pagination.pageOf': 'Stran {page} od {total}',
  'status.open': 'Odprt',
  'status.to_be_prioritised': 'Čaka na prednostno razvrstitev',
  'status.work_in_progress': 'V obdelavi',
  'status.assigned_to_ai_agent': 'Dodeljen AI agentu',
  'status.cto_approval_pending': 'CTO Approval Pending',
  'status.po_approval_pending': 'PO Approval Pending',
  'status.rm_approval_pending': 'RM Approval Pending',
  'status.rework_required': 'Rework Required',
  'status.approved': 'Approved',
  'status.rejected': 'Rejected',
  'status.pending': 'V čakanju',
  'status.awaiting_user_reply': 'Čaka na odgovor uporabnika',
  'status.awaiting_resolution_confirmation': 'Čaka na potrditev rešitve',
  'status.on_hold': 'Zadržan',
  'status.pending_production_release': 'Čaka na izdajo v produkcijo',
  'status.product_cr': 'Produktni CR',
  'status.reopened': 'Ponovno odprt',
  'status.issue_fixed': 'Težava odpravljena',
  'status.resolved': 'Rešen',
  'status.closed': 'Zaprt',
  'status.unknown': 'Neznano',
  'priority.low': 'Nizka',
  'priority.medium': 'Srednja',
  'priority.high': 'Visoka',
  'priority.urgent': 'Nujna',
  'source.email': 'E-pošta',
  'source.portal': 'Portal',
  'source.phone': 'Telefon',
  'source.chat': 'Klepet',
  'source.whatsapp': 'WhatsApp',
  'source.web_chat': 'Spletni klepet',
  'source.web_form': 'Spletni obrazec',
  'source.forum': 'Forum',
  'source.facebook': 'Facebook',
  'source.mobihelp': 'MobiHelp',
  'source.feedback_widget': 'Gradnik za povratne informacije',
  'source.outbound_email': 'Odhodna e-pošta',
  'source.ecommerce': 'Spletna trgovina',
  'source.bot': 'Bot',
  'source.instagram_message': 'Sporočilo na Instagramu',
  'source.instagram_comment': 'Komentar na Instagramu',
  'source.facebook_message': 'Sporočilo na Facebooku',
  'source.facebook_comment': 'Komentar na Facebooku',
  'source.mobile_chat_sdk': 'Mobilni klepetalni SDK',
  'source.sms': 'SMS',
  'source.api': 'API',
  'savedViews.title': 'Shranjeni pogledi',
  'savedViews.saveCurrent': 'Shrani trenutne filtre kot pogled',
  'savedViews.namePlaceholder': 'Ime pogleda...',
  'savedViews.nameAria': 'Ime pogleda',
  'savedViews.empty': 'Ni shranjenih pogledov. Uporabite filtre in jih shranite tukaj.',
  'savedViews.listAria': 'Seznam shranjenih pogledov',
  'savedViews.rename': 'Preimenuj pogled „{name}“',
  'savedViews.delete': 'Izbriši pogled „{name}“',
  'export.title': 'Izvozi zahtevke',
  'export.loadError': 'Seznama polj za izvoz ni bilo mogoče naložiti.',
  'export.failed': 'Izvoz ni uspel. Poskusite znova.',
  'export.pdfFailed': 'Izvoz v PDF ni uspel. Poskusite znova.',
  'export.fieldsSelectedOne': 'Izbrano {count} polje',
  'export.fieldsSelectedMany': 'Izbranih polj: {count}',
  'export.fieldsTotalOne': 'Skupaj {count} polje',
  'export.fieldsTotalMany': 'Skupaj polj: {count}',
  'export.selectAllFields': 'Izberi vsa polja',
  'export.exportingOne': 'Izvaža se 1 izbran zahtevek.',
  'export.exportingMany': 'Izvaža se izbranih zahtevkov: {count}.',
  'export.pdfZip': 'Prenesi kot PDF (.zip, datotek: {count})',
  'export.pdf': 'Prenesi kot PDF',
  'export.pdfZipHint': 'Ustvari en PDF za vsak zahtevek in jih stisne v eno samo datoteko ZIP za prenos.',
  'export.pdfHint': 'Ustvari en sam PDF z lastnostmi zahtevka in javno nit pogovora.',
  'export.formatLabel': 'Izvozi kot (CSV / Excel)',
  'export.csv': 'CSV',
  'export.excel': 'Excel',
  'export.loadingFields': 'Nalaganje seznama polj…',
  'export.ticketFields': 'Polja zahtevka',
  'export.contactFields': 'Polja stika',
  'export.companyFields': 'Polja podjetja',
  'export.exporting': 'Izvažanje…',
  'newTicket.title': 'Ustvari zahtevek',
  'newTicket.description': 'Izberite shranjen obrazec in izpolnite njegova polja.',
  'newTicket.form': 'Obrazec zahtevka',
  'newTicket.noForms': 'Ni razpoložljivih obrazcev zahtevkov. Pred ustvarjanjem zahtevka nastavite obrazec.',
  'newTicket.loadFormsError': 'Obrazcev zahtevkov ni bilo mogoče naložiti',
  'newTicket.loadFormError': 'Izbranega obrazca zahtevka ni bilo mogoče naložiti',
  'newTicket.addCc': 'Dodaj CC',
  'newTicket.cc': 'CC',
  'newTicket.removeFile': 'Odstrani {name}',
  'newTicket.requesterRequired': 'Prosilec je obvezen',
  'newTicket.subjectRequired': 'Zadeva je obvezna',
  'newTicket.createFailed': 'Zahtevka ni bilo mogoče ustvariti',
  'newTicket.noFormTitle': 'Noben obrazec zahtevka ni na voljo',
  'newTicket.noFormDescription': 'Ustvarite obrazec zahtevka v Nastavitvah in se nato vrnite, da odprete zahtevek.',
  'newTicket.noFieldsTitle': 'Ta obrazec še nima polj',
  'newTicket.noFieldsDescription': 'Dodajte polja obrazcu v Nastavitvah in nato znova naložite to stran.',
  'newTicket.creating': 'Ustvarjanje...',
  'newTicket.submit': 'Ustvari zahtevek',
  'fields.required': 'Polje {label} je obvezno',
  'fields.selectParentFirst': 'Najprej izberite nadrejeno vrednost...',
  'fields.selectPlaceholder': 'Izberite {label}...',
  'fields.enterPlaceholder': 'Vnesite {label}...',
  'fields.optionsLoadError': 'Možnosti za {label} ni bilo mogoče naložiti',
  'fields.label.requester': 'Prosilec',
  'fields.label.subject': 'Zadeva',
  'fields.label.description': 'Opis',
  'fields.label.status': 'Stanje',
  'fields.label.priority': 'Prioriteta',
  'fields.label.source': 'Vir',
  'fields.label.ticket_type': 'Vrsta',
  'fields.label.agent': 'Agent',
  'fields.label.group': 'Skupina',
  'fields.label.internal_agent': 'Notranji agent',
  'fields.label.internal_group': 'Notranja skupina',
  'fields.label.company': 'Podjetje',
  'editor.defaultPlaceholder': 'Pišite tukaj...',
  'editor.ariaLabel': 'Urejevalnik obogatenega besedila',
  'editor.toolbarAria': 'Oblikovanje besedila',
  'editor.bold': 'Krepko (Ctrl+B)',
  'editor.italic': 'Ležeče (Ctrl+I)',
  'editor.underline': 'Podčrtano (Ctrl+U)',
  'editor.strikethrough': 'Prečrtano',
  'editor.heading1': 'Naslov 1',
  'editor.heading2': 'Naslov 2',
  'editor.textColor': 'Barva besedila',
  'editor.highlight': 'Označitev',
  'editor.bulletList': 'Seznam z alinejami',
  'editor.numberedList': 'Oštevilčen seznam',
  'editor.blockquote': 'Citat',
  'editor.codeBlock': 'Blok kode',
  'editor.insertLink': 'Vstavi povezavo',
  'editor.insertImage': 'Vstavi sliko',
  'editor.insertTable': 'Vstavi tabelo',
  'editor.mention': 'Omeni nekoga',
  'editor.undo': 'Razveljavi (Ctrl+Z)',
  'editor.redo': 'Uveljavi (Ctrl+Shift+Z)',
  'editor.attach': 'Priloži datoteko',
  'editor.noAgents': 'Ni najdenih agentov',
  'editor.mentionSuggestions': 'Predlogi za omembo',
  'editor.dialogLinkTitle': 'Vstavi povezavo',
  'editor.dialogImageTitle': 'Vstavi sliko',
  'editor.linkHint': 'Vnesite URL HTTP(S), mailto, sidro ali relativni URL.',
  'editor.imageHint': 'Vnesite URL slike HTTP(S) ali relativni URL.',
  'editor.url': 'URL',
  'editor.invalidLink': 'Vnesite veljaven URL HTTP(S), mailto, sidro ali relativni URL.',
  'editor.invalidImage': 'Vnesite veljaven URL slike HTTP(S) ali relativni URL.',
  'editor.selectTextForLink': 'Pred dodajanjem povezave izberite besedilo.',
  'editor.imageInsertFailed': 'Slike ni bilo mogoče vstaviti sem.',
  'editor.insertLinkAction': 'Vstavi povezavo',
  'editor.insertImageAction': 'Vstavi sliko',
  'search.dialogAria': 'Globalno iskanje',
  'search.placeholder': 'Išči zahtevke, stike...',
  'search.aria': 'Iskanje',
  'search.close': 'Zapri iskanje',
  'search.noMatches': 'Ni zadetkov za „{query}“',
  'search.noMatchesHint': 'Poskusite s številko zahtevka, e-pošto stika ali imenom podjetja.',
  'search.hintBefore': 'Za iskanje vnesite vsaj 2 znaka. Pritisnite',
  'search.hintAfter': 'za zapiranje.',

  'td.system': 'Sistem',
  'td.actionCreatedTicket': 'je ustvaril(-a) zahtevek',
  'td.actionUpdatedFields': 'je posodobil(-a): {fields}',
  'td.fieldStatus': 'stanje',
  'td.fieldPriority': 'prioriteta',
  'td.fieldSource': 'vir',
  'td.fieldType': 'vrsta',
  'td.fieldGroup': 'skupina',
  'td.fieldAgent': 'agent',
  'td.fieldCompany': 'podjetje',
  'td.fieldContact': 'stik',
  'td.fieldSubject': 'zadeva',
  'td.fieldDescription': 'opis',
  'td.fieldProduct': 'izdelek',
  'td.fieldResolutionDue': 'rok za rešitev',
  'td.fieldFirstResponseDue': 'rok za prvi odziv',
  'td.fieldTags': 'oznake',
  'td.fieldParentTicket': 'nadrejeni zahtevek',
  'td.eventCreated': '{actor} je ustvaril(-a) nov zahtevek',
  'td.eventCreatedLinked': '{actor} je ustvaril(-a) nov zahtevek in ga povezal(-a) z nadrejenim zahtevkom',
  'td.eventSplit': '{actor} je razdelil(-a) ta zahtevek in ustvaril(-a) podrejeni zahtevek{ref}',
  'td.eventMergeReceived': '{actor} je v ta zahtevek združil(-a) drug zahtevek{ref}',
  'td.eventMerged': '{actor} je ta zahtevek združil(-a) z drugim zahtevkom{ref}',
  'td.eventSplitCopied': '{actor} je kopiral(-a) {conversations} in {attachments}',
  'td.conversationsOne': '{count} pogovor',
  'td.conversationsMany': 'št. pogovorov: {count}',
  'td.attachmentsOne': '{count} prilogo',
  'td.attachmentsMany': 'št. prilog: {count}',
  'td.eventUpdatedFields': '{actor} je posodobil(-a): {fields}',
  'td.invalidSlaState': 'Strežnik je vrnil neveljavno stanje SLA.',
  'td.slaRefreshError': 'Ur SLA ni bilo mogoče osvežiti.',
  'td.descriptionUpdated': 'Opis je posodobljen',
  'td.descriptionUpdateError': 'Opisa ni bilo mogoče posodobiti',
  'td.descriptionUpdateFailed': 'Posodobitev opisa ni uspela',
  'td.entryUpdated': 'Vnos je posodobljen',
  'td.entryUpdateError': 'Vnosa ni bilo mogoče posodobiti',
  'td.updateFailed': 'Posodobitev ni uspela',
  'td.loadOlderError': 'Starejših pogovorov ni bilo mogoče naložiti',
  'td.loadFailed': 'Nalaganje ni uspelo',
  'td.slaUpdateFailed': 'Posodobitev SLA ni uspela',
  'td.reasonTooLong': 'Razlog ne sme presegati 500 znakov.',
  'td.invalidDateTime': 'Izberite veljaven datum in čas.',
  'td.slaDeadlineUpdated': 'Rok SLA je posodobljen',
  'td.slaConflict': 'Zahtevek se je spremenil med urejanjem podatkov SLA. Pred ponovnim poskusom osvežite stran.',
  'td.slaClearFailed': 'Brisanje SLA ni uspelo',
  'td.slaTargetCleared': 'Cilj SLA je izbrisan',
  'td.slaClearError': 'Cilja SLA ni bilo mogoče izbrisati',
  'td.noDescription': 'Opis še ni dodan.',
  'td.editDescriptionAria': 'Uredi opis zahtevka',
  'td.download': 'Prenesi',
  'td.downloadFile': 'Prenesi {fileName}',
  'td.loadOlder': '↓ +{count} pogovor',
  'td.loadOlderMany': '↓ +{count} pogovorov',
  'td.edited': '(urejeno)',
  'td.privateThread': 'Zasebna nit',
  'td.propertiesAria': 'Lastnosti zahtevka',
  'td.expandProperties': 'Razširi lastnosti',
  'td.collapseProperties': 'Strni lastnosti',
  'td.metric': 'Metrika',
  'td.firstResponseOption': 'Prvi odziv',
  'td.resolutionOption': 'Rešitev',
  'td.overrideHint': 'Nastavite prepis roka, ki ga določa strežnik. Razlog se hrani v zgodovini SLA.',
  'td.deadline': 'Rok',
  'td.reasonOptional': 'Razlog (neobvezno)',
  'td.reasonPlaceholder': 'Odobrena izjema ali operativni kontekst',
  'td.clearResolutionOverride': 'Izbriši prepis roka za rešitev',
  'td.clearEscalationTarget': 'Izbriši cilj eskalacije',
  'td.toolsAria': 'Orodja zahtevka in stik',
  'td.ticketContext': 'Kontekst zahtevka',
  'td.knowledgeBase': 'Zbirka znanja',
  'td.shortcutsAria': 'Bližnjice konteksta zahtevka',
  'td.showContext': 'Pokaži kontekst zahtevka',
  'td.hideContext': 'Skrij kontekst zahtevka',
  'td.openRow': 'Odpri: {label}',
  'td.editTicket': 'Uredi zahtevek',
  'td.searchContactPlaceholder': 'Išči stik …',
  'td.describePlaceholder': 'Opišite težavo …',
  'td.noAttachments': 'Ni prilog',

  'tp.api.csrfUnavailable': 'Zaščite CSRF ni bilo mogoče vzpostaviti',
  'tp.api.noMfaChallenge': 'Noben izziv MFA ni aktiven',
  'tp.api.noMfaSetup': 'Noben izziv za nastavitev MFA ni aktiven',
  'tp.api.noNewPasswordChallenge': 'Noben izziv za novo geslo ni aktiven',
  'tp.articles.isLinkedAria': '{title} je povezan kot rešitev',
  'tp.articles.linkAria': 'Poveži {title} kot rešitev',
  'tp.articles.linkAsSolution': 'Poveži kot rešitev',
  'tp.articles.linkedAsSolution': 'Povezano kot rešitev',
  'tp.articles.none': 'Za ta zahtevek ni predlaganih člankov.',
  'tp.articles.title': 'Predlagani članki',
  'tp.articles.views': 'Ogledov: {count}',
  'tp.attachment.loadingPreview': 'Nalaganje predogleda …',
  'tp.attachment.previewUnavailable': 'Predogled ni na voljo',
  'tp.charts.noData': 'Za to obdobje ni podatkov za grafikon.',
  'tp.charts.noRecords': 'V tem obdobju ni zapisov.',
  'tp.charts.period': 'Obdobje',
  'tp.charts.showingTop': 'Prikazanih je prvih {shown} od {total} segmentov.',
  'tp.common.cancel': 'Prekliči',
  'tp.common.clear': 'Počisti',
  'tp.common.loading': 'Nalaganje …',
  'tp.common.send': 'Pošlji',
  'tp.common.sending': 'Pošiljanje …',
  'tp.common.system': 'Sistem',
  'tp.convActions.edit': 'Uredi',
  'tp.convActions.thread': 'Začni nit',
  'tp.dashboard.new': 'Nova',
  'tp.dashboard.select': 'Izberite nadzorno ploščo',
  'tp.forward.failed': 'Posredovanje ni uspelo',
  'tp.forward.forwarded': 'Zahtevek je posredovan',
  'tp.forward.forwarding': 'Posredovanje …',
  'tp.forward.forwardingMany': 'Posredovanje pogovorov ({count}):',
  'tp.forward.forwardingOne': 'Posredovanje 1 pogovora:',
  'tp.forward.message': 'Sporočilo',
  'tp.forward.messagePlaceholder': 'Dodajte sporočilo (neobvezno) …',
  'tp.forward.noContacts': 'Stikov ni mogoče najti — vnesite celoten e-poštni naslov',
  'tp.forward.recipientEmail': 'E-pošta prejemnika',
  'tp.forward.recipientInvalid': 'Vnesite veljaven e-poštni naslov prejemnika',
  'tp.forward.recipientRequired': 'E-pošta prejemnika je obvezna',
  'tp.forward.searchContact': 'Poiščite stik ali vnesite e-pošto …',
  'tp.forward.title': 'Posreduj',
  'tp.forward.to': 'Za',
  'tp.forward.useThisEmail': 'Pritisnite Enter ali kliknite Posreduj, da uporabite to e-pošto',
  'tp.jira.addOptional': 'Dodaj neobvezna polja',
  'tp.jira.createAndLink': 'Ustvari in poveži zadevo',
  'tp.jira.createIssue': 'Ustvari zadevo',
  'tp.jira.createTitle': 'Ustvari zadevo Jira',
  'tp.jira.describePlaceholder': 'Opišite težavo …',
  'tp.jira.description': 'Opis',
  'tp.jira.development': 'Razvoj',
  'tp.jira.enterDevelopment': 'Vnesite razvoj',
  'tp.jira.hideOptional': 'Skrij neobvezna polja',
  'tp.jira.issueId': 'ID zadeve',
  'tp.jira.issueSummary': 'Povzetek zadeve',
  'tp.jira.issueType': 'Vrsta zadeve *',
  'tp.jira.lastSync': 'Zadnja sinhronizacija: {error}',
  'tp.jira.linkIssue': 'Poveži zadevo',
  'tp.jira.linkTitle': 'Poveži zadevo Jira',
  'tp.jira.linkedIssues': 'Povezane zadeve',
  'tp.jira.linkedIssuesHint': 'Uporabite ključe zadev Jira, ločene z vejicami.',
  'tp.jira.linkedIssuesPlaceholder': 'npr. SUP-123, SUP-456',
  'tp.jira.loadingFields': 'Nalaganje polj Jira …',
  'tp.jira.loadingIssueTypes': 'Nalaganje vrst zadev …',
  'tp.jira.loadingProjects': 'Nalaganje projektov Jira …',
  'tp.jira.loadingUsers': 'Nalaganje uporabnikov Jira …',
  'tp.jira.noLinks': 'S tem zahtevkom še ni povezana nobena zadeva Jira.',
  'tp.jira.noneFound': 'Zadev Jira ni bilo mogoče najti.',
  'tp.jira.notAvailableProject': 'Za ta projekt ni na voljo',
  'tp.jira.projects': 'Projekti *',
  'tp.jira.refresh': 'Osveži',
  'tp.jira.refreshFields': 'Osveži polja Jira',
  'tp.jira.reporter': 'Prijavitelj',
  'tp.jira.requestFailed': 'Zahteva Jira ni uspela. Poskusite znova.',
  'tp.jira.searchBy': 'Išči po:',
  'tp.jira.searchIssue': 'Išči zadevo',
  'tp.jira.searchIssuePlaceholder': 'Išči zadevo …',
  'tp.jira.searchUsers': 'Išči uporabnike Jira',
  'tp.jira.searching': 'Iskanje v Jira …',
  'tp.jira.selectIssueType': 'Izberite vrsto zadeve',
  'tp.jira.selectProject': 'Izberite projekt',
  'tp.jira.summary': 'Povzetek *',
  'tp.jira.syncOff': 'Sinhronizacija izklopljena',
  'tp.jira.syncOn': 'Sinhronizacija vklopljena',
  'tp.jira.syncStatus': 'Sinhroniziraj stanje zahtevka z Jira',
  'tp.jira.unassigned': 'Ni dodeljeno',
  'tp.jira.unlink': 'Odstrani povezavo',
  'tp.jira.unlinkConfirm': 'Odstrani povezavo zadeve',
  'tp.jira.unlinkDescription': 'S tem se odstrani povezava z zahtevkom, zadeva Jira pa se ne izbriše.',
  'tp.jira.unlinkTitle': 'Odstranite povezavo {key}?',
  'tp.jira.untitled': 'Zadeva Jira brez naslova',
  'tp.layout.loadingPage': 'Nalaganje strani …',
  'tp.notFound.goToDashboard': 'Pojdi na nadzorno ploščo',
  'tp.notFound.title': 'Strani ni mogoče najti',
  'tp.portal.brand': 'Podpora SuzukiDesk',
  'tp.portal.customer': 'Stranka',
  'tp.reply.addNote': 'Dodaj opombo',
  'tp.reply.attachmentNotAdded': 'Priloga ni dodana',
  'tp.reply.clickToExpand': 'Kliknite za razširitev',
  'tp.reply.collapsedNote': 'Dodajte interno opombo …',
  'tp.reply.collapsedReply': 'Napišite odgovor ali opombo …',
  'tp.reply.conversationType': 'Vrsta pogovora',
  'tp.reply.failedToSend': 'Pošiljanje ni uspelo',
  'tp.reply.markNoteAs': 'Označi opombo kot',
  'tp.reply.notVisibleToContact': 'Stiku ni vidno',
  'tp.reply.notVisibleToContacts': 'Stikom ni vidno',
  'tp.reply.noteAdded': 'Opomba je dodana',
  'tp.reply.notifyTo': 'Obvesti',
  'tp.reply.placeholderPrivateNote': 'Dodajte zasebno opombo ...',
  'tp.reply.placeholderPublicNote': 'Dodajte javno opombo, vidno prosilcu ...',
  'tp.reply.placeholderReply': 'Vnesite svoj odgovor ...',
  'tp.reply.private': 'Zasebno',
  'tp.reply.public': 'Javno',
  'tp.reply.removeFile': 'Odstrani {name}',
  'tp.reply.replySent': 'Odgovor je poslan',
  'tp.reply.searchAgentsToNotify': 'Poiščite agente za obvestilo …',
  'tp.reply.sendReply': 'Pošlji odgovor',
  'tp.reply.sending': 'Pošiljanje ...',
  'tp.reply.tabNote': 'Opomba',
  'tp.reply.tabReply': 'Odgovor',
  'tp.reply.uploadAttachment': 'Naloži prilogo',
  'tp.reply.visibleToContact': 'Vidno stiku',
  'tp.reply.visibleToContacts': 'Vidno stikom',
  'tp.sla.breached': 'Kršeno',
  'tp.sla.cleared': 'Izbrisano',
  'tp.sla.configErrorNoDeadline': 'Napaka v konfiguraciji SLA. Rok ni določen.',
  'tp.sla.configurationError': 'Napaka v konfiguraciji',
  'tp.sla.couldNotLoad': 'Ur SLA ni bilo mogoče naložiti',
  'tp.sla.done': 'Opravljeno',
  'tp.sla.dueIn': 'Rok čez {duration}',
  'tp.sla.dueLine': 'Rok: {date}',
  'tp.sla.dueNow': 'Rok je zdaj',
  'tp.sla.escalated': 'Eskalirano',
  'tp.sla.firstResponse': 'Prvi odziv',
  'tp.sla.invalidDeadline': 'Neveljaven rok',
  'tp.sla.mayBeStale': 'Ure SLA so morda zastarele',
  'tp.sla.noActiveCycle': 'Ni aktivnega cikla SLA.',
  'tp.sla.noDeadline': 'Brez roka',
  'tp.sla.noMetrics': 'Za ta cikel ni na voljo nobenih metrik SLA.',
  'tp.sla.noPolicy': 'Za ta zahtevek ni uporabljeno nobeno pravilo SLA.',
  'tp.sla.notConfigured': 'Ni konfigurirano',
  'tp.sla.notStarted': 'Ni začeto',
  'tp.sla.overdueBy': 'Zapadlo za {duration}',
  'tp.sla.overridden': 'Prepisano',
  'tp.sla.overrideReason': 'Razlog za prepis: {reason}',
  'tp.sla.paused': 'Zaustavljeno',
  'tp.sla.refreshing': 'Osveževanje avtoritativnih ur SLA …',
  'tp.sla.resolution': 'Rešitev',
  'tp.sla.stopsSla': 'Ustavi SLA',
  'tp.thread.empty': 'Še ni bilo poslano nič. Vaše prvo sporočilo bo začelo to zasebno nit.',
  'tp.thread.messageFailed': 'Sporočilo ni uspelo',
  'tp.thread.privateThread': 'Zasebna nit',
  'tp.thread.replyPlaceholder': 'Odgovorite v niti …',
  'tp.thread.someone': 'Nekdo',
  'tp.thread.startPrivateThread': 'Začni zasebno nit',
  'tp.thread.startedBy': '{name} je začel(-a) to nit',
  'tp.thread.unableToSend': 'Sporočila ni bilo mogoče poslati',
  'tp.ui.breadcrumb': 'Drobtinice',
  'tp.ui.closePanel': 'Zapri ploščo',
  'tp.ui.dismiss': 'Opusti: {title}',

  'dir.loadError': 'Podatkov ni bilo mogoče naložiti. Poskusite znova.',
  'dir.contacts.description': 'Stiki strank in njihova zgodovina podpore.',
  'dir.contacts.searchAria': 'Iskanje stikov',
  'dir.contacts.count': 'Stikov: {count}',
  'dir.contacts.noMatch': 'Temu iskanju ne ustreza noben stik',
  'dir.contacts.none': 'Stikov še ni',
  'dir.contacts.noneDescription': 'Stiki se bodo prikazali tukaj, ko bodo stranke začele oddajati zahtevke.',
  'dir.company': 'Podjetje',
  'dir.unnamedContact': 'Stik brez imena',
  'dir.contact': 'Stik',
  'dir.contactNotFound': 'Stika ni mogoče najti.',
  'dir.confirmDeleteContactTitle': 'Izbrišete „{name}“?',
  'dir.thisContact': 'ta stik',
  'dir.confirmDeleteContactDescription': 'Stiki z zahtevki bodo deaktivirani in ne trajno izbrisani.',
  'dir.deleteContact': 'Izbriši stik',
  'dir.editProfile': 'Uredi profil',
  'dir.profile': 'Profil',
  'dir.firstName': 'Ime',
  'dir.lastName': 'Priimek',
  'dir.phone': 'Telefon',
  'dir.timezone': 'Časovni pas',
  'dir.emailLabel': 'E-pošta:',
  'dir.phoneLabel': 'Telefon:',
  'dir.companyLabel': 'Podjetje:',
  'dir.timezoneLabel': 'Časovni pas:',
  'dir.recentTickets': 'Nedavni zahtevki',
  'dir.noTicketsYet': 'Zahtevkov še ni',
  'dir.contactTicketsDescription': 'Zahtevki, ki jih je vložil ta stik, bodo navedeni tukaj.',
  'dir.ticket': 'Zahtevek',
  'dir.subject': 'Zadeva',
  'dir.status': 'Stanje',
  'dir.created': 'Ustvarjeno',
  'dir.companies.description': 'Organizacije, povezane s stiki strank in zahtevki.',
  'dir.companies.add': 'Dodaj podjetje',
  'dir.companies.domain': 'Domena',
  'dir.companies.create': 'Ustvari podjetje',
  'dir.companies.searchAria': 'Iskanje podjetij',
  'dir.companies.searchPlaceholder': 'Išči podjetja ali domene',
  'dir.companies.noMatch': 'Temu iskanju ne ustreza nobeno podjetje',
  'dir.companies.addFirst': 'Dodajte svoje prvo podjetje',
  'dir.companies.tryDifferent': 'Poskusite z drugim imenom podjetja ali domeno.',
  'dir.companies.useForm': 'Za ustvarjanje podjetja uporabite obrazec ob tem seznamu.',
  'dir.companies.contacts': 'Stiki',
  'dir.companies.tickets': 'Zahtevki',
  'dir.companies.notFound': 'Podjetja ni mogoče najti.',
  'dir.companies.confirmDeleteTitle': 'Izbrišete „{name}“?',
  'dir.companies.thisCompany': 'to podjetje',
  'dir.companies.confirmDeleteDescription': 'Podjetje ne sme imeti stikov ali zahtevkov, da ga je mogoče izbrisati.',
  'dir.companies.delete': 'Izbriši podjetje',
  'dir.companies.noDomain': 'Domena ni konfigurirana',
  'dir.companies.contactsCount': 'Stiki ({count})',
  'dir.companies.ticketsCount': 'Zahtevki ({count})',
  'dir.companies.noContactsDescription': 'Dodajte stik in ga povežite s tem podjetjem, da se prikaže tukaj.',
  'dir.companies.noTicketsDescription': 'Zahtevki, ki so jih vložili stiki tega podjetja, bodo navedeni tukaj.',
  'dir.trendsCreatedHour': 'Datum nastanka – ura dneva',
  'dir.reports.loadError': 'Tega poročila ni bilo mogoče naložiti. Poskusite znova.',
  'dir.reports.volume': 'Obseg zahtevkov',
  'dir.reports.sla': 'Skladnost s SLA',
  'dir.reports.agents': 'Uspešnost agentov',
  'dir.reports.csat': 'Zadovoljstvo strank',
  'dir.reports.rca': 'Analiza vzrokov',
  'dir.reports.descVolume': 'Poglejte, od kod prihajajo zahtevki in kako potekajo skozi življenjski cikel.',
  'dir.reports.descSla': 'Spremljajte cilje odziva in rešitve v dostopnem podpornem poslovanju.',
  'dir.reports.descAgents': 'Primerjajte delovno obremenitev, izide, odgovore in povprečne čase obravnave po agentih.',
  'dir.reports.descCsat': 'Preberite mnenje strank, ne da bi obseg odzivov zamenjali za stopnjo zadovoljstva.',
  'dir.reports.descRca': 'Poiščite standardizirane vzroke za povpraševanje po zahtevkih.',
  'dir.reports.noPayload': 'Za to obdobje ni bilo vrnjenih podatkov poročila.',
  'dir.reports.refresh': 'Osveži',
  'dir.reports.report': 'Poročilo',
  'dir.reports.from': 'Od',
  'dir.reports.to': 'Do',
  'dir.reports.maxRange': 'Največji obseg: 90 dni · obseg sledi dovoljenjem vašega računa.',
  'dir.reports.unclassified': 'Nerazvrščeno',
  'dir.reports.ticketsInPeriod': 'Zahtevki v obdobju',
  'dir.reports.ticketsInPeriodDetail': 'Dostopni zahtevki, ki jih vrne poročilo',
  'dir.reports.created': 'Ustvarjeno',
  'dir.reports.createdDetail': 'Po izbrani datumski osi',
  'dir.reports.resolved': 'Rešeno',
  'dir.reports.resolvedDetail': '{percent} % ustvarjenega obsega',
  'dir.reports.noCreated': 'Ni ustvarjenih zahtevkov',
  'dir.reports.reopened': 'Ponovno odprto',
  'dir.reports.reopenedDetail': 'Dogodki življenjskega cikla, ne edinstveni zahtevki',
  'dir.reports.dailyPulse': 'Dnevni utrip',
  'dir.reports.volumeByDate': 'Obseg zahtevkov po datumu',
  'dir.reports.volumeByDateDescription': 'Redke vrstice iz zaledja so razširjene v popolno datumsko os, napolnjeno z ničlami.',
  'dir.reports.createdTickets': 'Ustvarjeni zahtevki',
  'dir.reports.createdVolumeAria': 'Obseg ustvarjenih zahtevkov po datumu',
  'dir.reports.lifecycle': 'Življenjski cikel',
  'dir.reports.lifecycleTitle': 'Ustvarjeno, rešeno, ponovno odprto',
  'dir.reports.lifecycleDescription': 'Tri črte prikazujejo gibanje skozi življenjski cikel zahtevka.',
  'dir.reports.lifecycleAria': 'Dogodki življenjskega cikla zahtevkov po datumu',
  'dir.reports.dimensions': 'Razsežnosti',
  'dir.reports.whereConcentrated': 'Kje je obseg skoncentriran',
  'dir.reports.topEight': 'Na ploščo je prikazanih osem najpomembnejših segmentov',
  'dir.reports.status': 'Stanje',
  'dir.reports.statusDescription': 'Trenutno stanje zahtevka',
  'dir.reports.priority': 'Prioriteta',
  'dir.reports.priorityDescription': 'Razmerje prioritet zahtevkov',
  'dir.reports.group': 'Skupina',
  'dir.reports.groupDescription': 'Skupine za usmerjanje',
  'dir.reports.agent': 'Agent',
  'dir.reports.agentDescription': 'Dodeljeno lastništvo',
  'dir.reports.product': 'Izdelek',
  'dir.reports.productDescription': 'Razmerje izdelkov',
  'dir.reports.country': 'Država',
  'dir.reports.countryDescription': 'Iz standardiziranih polj države',
  'dir.reports.noRecords': 'V tem obdobju ni zapisov.',
  'dir.reports.slaSummary': '{rate} · izpolnjeno {met} od {total}',
  'dir.reports.noSlaSegments': 'Segmentov SLA še ni',
  'dir.reports.noSlaSegmentsDescription': 'Za to razsežnost v izbranem obdobju ni ustreznih zapisov SLA.',
  'dir.reports.segment': 'Segment',
  'dir.reports.firstResponse': 'Prvi odziv',
  'dir.reports.resolution': 'Rešitev',
  'dir.reports.avgFirstResponse': 'Povpr. prvi odziv',
  'dir.reports.avgResolution': 'Povpr. rešitev',
  'dir.reports.fromTicketMetric': 'Iz TicketMetric',
  'dir.reports.slaLens': 'Pogled SLA',
  'dir.reports.performanceBySegment': 'Uspešnost po segmentih',
  'dir.reports.slaRatesNote': 'Stopnje upoštevajo samo zapise z ustreznim ciljem SLA. Trajanja so povprečni pretekli čas.',
  'dir.reports.slaDimensionAria': 'Razsežnost razčlenitve SLA',
  'dir.reports.rosterSignal': 'Signal ekipe',
  'dir.reports.agentPerformance': 'Uspešnost agentov',
  'dir.reports.agentPerformanceDescription': 'Vključen je vsak aktivni agent, tudi tisti brez dejavnosti.',
  'dir.reports.filterAgentsAria': 'Filtriraj agente',
  'dir.reports.filterAgentsPlaceholder': 'Filtriraj po agentu ali e-pošti',
  'dir.reports.matchingAgents': 'Ustreznih agentov: {count}',
  'dir.reports.activeAgents': 'Aktivnih agentov: {count}',
  'dir.reports.sortedBy': 'razvrščeno po {key} {direction}',
  'dir.reports.asc': 'naraščajoče',
  'dir.reports.desc': 'padajoče',
  'dir.reports.noAgentsMatch': 'Temu filtru ne ustreza noben agent',
  'dir.reports.assigned': 'Dodeljeno',
  'dir.reports.replies': 'Odgovori',
  'dir.reports.csatScore': 'Ocena CSAT',
  'dir.reports.csatScoreDetail': 'Ocene 4 ali 5',
  'dir.reports.averageRating': 'Povprečna ocena',
  'dir.reports.averageRatingDetail': 'Med ocenjenimi anketami',
  'dir.reports.ratedSurveys': 'Ocenjene ankete',
  'dir.reports.ratedSurveysDetail': 'V izbranem obdobju',
  'dir.reports.satisfied': 'Zadovoljni',
  'dir.reports.satisfiedDetail': 'Pozitivni odzivi',
  'dir.reports.responseTrend': 'Trend odzivov',
  'dir.reports.surveyVolume': 'Obseg anket po datumu',
  'dir.reports.surveyVolumeDescription': 'Zaledje vrne število odzivov po datumu; to ni dnevna ocena. Spodaj je vzorčenih zadnjih 100 odzivov.',
  'dir.reports.surveyResponses': 'Odzivi na ankete',
  'dir.reports.surveyVolumeAria': 'Obseg odzivov na ankete CSAT po datumu',
  'dir.reports.responsesByGroup': 'Odzivi po skupinah',
  'dir.reports.responsesByGroupDescription': 'Število odzivov na ankete, ne stopnja zadovoljstva skupine',
  'dir.reports.responsesByAgent': 'Odzivi po agentih',
  'dir.reports.responsesByAgentDescription': 'Število odzivov na ankete, ne stopnja zadovoljstva agenta',
  'dir.reports.customerVoice': 'Glas strank',
  'dir.reports.latestSurveys': 'Zadnji odzivi na ankete',
  'dir.reports.boundedSample': 'Omejen vzorec · {count} od največ 100',
  'dir.reports.latestSurveysNote': 'Najnovejši odzivi, ki jih vrne API za poročanje. Uporabite to tabelo za hiter pregled, ne za popoln izvoz.',
  'dir.reports.noSurveys': 'Ni odzivov na ankete',
  'dir.reports.noSurveysDescription': 'Odzivi CSAT se bodo prikazali tukaj, ko bodo stranke ocenile rešen zahtevek.',
  'dir.reports.rating': 'Ocena',
  'dir.reports.comment': 'Komentar',
  'dir.reports.received': 'Prejeto',
  'dir.reports.ratingOutOf': '{rating} od 5',
  'dir.reports.noComment': 'Brez komentarja',
  'dir.reports.rcaEyebrow': 'Analiza vzrokov',
  'dir.reports.rcaTitle': 'Zakaj se vlagajo zahtevki',
  'dir.reports.rcaDescription': 'Kategorija in podkategorija sta neodvisna agregata iz standardiziranih polj po meri zahtevkov.',
  'dir.reports.rcaDimensionAria': 'Razsežnost RCA',
  'dir.reports.category': 'Kategorija',
  'dir.reports.subcategory': 'Podkategorija',
  'dir.reports.rcaEmpty': 'Za to obdobje ni bilo zabeleženih vrednosti vzrokov.',
  'dir.kb.articleLoadError': 'Članka ni bilo mogoče naložiti.',
  'dir.kb.articleNotFound': 'Članka ni mogoče najti.',
  'dir.kb.retry': 'Poskusi znova',
  'dir.kb.title': 'Zbirka znanja',
  'dir.kb.breadcrumb': 'Zbirka znanja',
  'dir.kb.description': 'Članki: {articles} v mapah: {folders}',
  'dir.kb.newArticle': 'Nov članek',
  'dir.kb.editArticle': 'Uredi članek',
  'dir.kb.sectionsAria': 'Razdelki zbirke znanja',
  'dir.kb.tabArticles': 'Članki',
  'dir.kb.tabStructure': 'Kategorije in mape',
  'dir.kb.folderFilterAria': 'Filter map',
  'dir.kb.allArticles': 'Vsi članki ({count})',
  'dir.kb.writeFirst': 'Napišite svoj prvi članek',
  'dir.kb.writeFirstDescription': 'Z gumbom Nov članek dodajte vsebino v to mapo.',
  'dir.kb.byAuthor': 'avtor: {name}',
  'dir.kb.views': 'Ogledov: {count}',
  'dir.kb.published': 'Objavljeno',
  'dir.kb.draft': 'Osnutek',
  'dir.kb.publish': 'Objavi',
  'dir.kb.unpublish': 'Prekliči objavo',
  'dir.kb.noFolders': 'V tej kategoriji ni map',
  'dir.kb.noFoldersDescription': 'Dodajte mapo, da začnete združevati članke.',
  'dir.kb.articlesCount': 'Člankov: {count}',
  'dir.kb.fieldTitle': 'Naslov',
  'dir.kb.folder': 'Mapa',
  'dir.kb.selectFolder': 'Izberite mapo',
  'dir.kb.content': 'Vsebina',
  'dir.kb.contentPlaceholder': 'Napišite vsebino članka ...',
  'dir.kb.tags': 'Oznake (ločene z vejicami)',
  'dir.kb.attachments': 'Priloge',
  'dir.kb.download': 'Prenesi',
  'dir.kb.downloadFile': 'Prenesi {name}',
  'dir.kb.remove': 'Odstrani',
  'dir.kb.removeFile': 'Odstrani {name}',
  'dir.kb.noAttachments': 'Prilog še ni.',
  'dir.kb.uploadAria': 'Naloži prilogo',
  'dir.kb.uploading': 'Nalaganje ...',
  'dir.kb.addFile': 'Dodaj datoteko',
  'dir.kb.confirmDeleteTitle': 'Izbrišete članek?',
  'dir.kb.confirmDeleteDescription': 'Ta objavljeni članek ali osnutek bo trajno izbrisan.',
  'dir.kb.confirmDeleteLabel': 'Izbriši članek',
  'dir.kb.confirmRemoveTitle': 'Odstranite prilogo?',
  'dir.kb.confirmRemoveDescription': 'Datoteka bo trajno odstranjena iz tega članka.',
  'dir.kb.confirmRemoveLabel': 'Odstrani prilogo',
  'dir.reports.rangeInvalid': 'Izberite veljavna začetni in končni datum.',
  'dir.reports.rangeOrder': 'Končni datum mora biti enak začetnemu datumu ali poznejši.',
  'dir.reports.rangeMax': 'Poročila podpirajo največ 90-dnevno obdobje.',

  'adm.active': 'Aktivno',
  'adm.auto.action.add_tag': 'dodaj oznako',
  'adm.auto.action.assign_agent': 'dodeli agenta',
  'adm.auto.action.assign_group': 'dodeli skupino',
  'adm.auto.action.send_email': 'pošlji e-pošto',
  'adm.auto.action.send_notification': 'pošlji obvestilo',
  'adm.auto.action.set_priority': 'nastavi prioriteto',
  'adm.auto.action.set_status': 'nastavi stanje',
  'adm.auto.actions': 'Dejanja',
  'adm.auto.addAction': '+ Dodaj dejanje',
  'adm.auto.addCondition': '+ Dodaj pogoj',
  'adm.auto.addRule': 'Dodaj pravilo',
  'adm.auto.colApplied': 'Uporabljena dejanja',
  'adm.auto.colDate': 'Datum',
  'adm.auto.colMatched': 'Ujemanje',
  'adm.auto.colSubject': 'Zadeva',
  'adm.auto.colTicket': 'Zahtevek',
  'adm.auto.conditions': 'Pogoji',
  'adm.auto.confirmDesc': 'To pravilo se bo takoj prenehalo izvajati in ga ni mogoče obnoviti.',
  'adm.auto.confirmLabel': 'Izbriši pravilo',
  'adm.auto.confirmTitle': 'Izbrišete pravilo avtomatizacije?',
  'adm.auto.countMany': 'Pravil avtomatizacije: {count}',
  'adm.auto.countOne': '{count} pravilo avtomatizacije',
  'adm.auto.create': 'Ustvari',
  'adm.auto.createFirst': 'Ustvarite svoje prvo pravilo avtomatizacije',
  'adm.auto.createFirstDesc': 'Z gumbom Dodaj pravilo samodejno usmerjajte, določajte prioriteto ali obveščajte.',
  'adm.auto.deleteFailed': 'Brisanje ni uspelo',
  'adm.auto.description': 'Pravila se izvajajo zaporedno glede na položaj. Pogoji znotraj pravila so povezani z AND.',
  'adm.auto.editRule': 'Uredi pravilo avtomatizacije',
  'adm.auto.execFailed': 'Izvajanj ni bilo mogoče naložiti',
  'adm.auto.field.assigneeId': 'odgovorna oseba',
  'adm.auto.field.companyId': 'podjetje',
  'adm.auto.field.groupId': 'skupina',
  'adm.auto.field.priority': 'prioriteta',
  'adm.auto.field.requesterId': 'prosilec',
  'adm.auto.field.source': 'vir',
  'adm.auto.field.status': 'stanje',
  'adm.auto.field.subject': 'zadeva',
  'adm.auto.field.ticketTypeId': 'vrsta zahtevka',
  'adm.auto.hits': 'Zadetki',
  'adm.auto.loadFailed': 'Pravil avtomatizacije ni bilo mogoče naložiti',
  'adm.auto.log': 'Dnevnik',
  'adm.auto.logTitle': 'Dnevnik izvajanja — {name}',
  'adm.auto.moveDown': 'Premakni navzdol',
  'adm.auto.moveUp': 'Premakni navzgor',
  'adm.auto.newRule': 'Novo pravilo avtomatizacije',
  'adm.auto.no': 'Ne',
  'adm.auto.noRuns': 'Izvajanj še ni',
  'adm.auto.noRunsDesc': 'Izvajanja se bodo prikazala tukaj, ko se bo to pravilo prvič ujemalo z zahtevkom.',
  'adm.auto.op.contains': 'vsebuje',
  'adm.auto.op.ends_with': 'se konča z',
  'adm.auto.op.greater_than': 'večje od',
  'adm.auto.op.in': 'v',
  'adm.auto.op.is': 'je',
  'adm.auto.op.is_empty': 'je prazno',
  'adm.auto.op.is_not': 'ni',
  'adm.auto.op.is_not_empty': 'ni prazno',
  'adm.auto.op.less_than': 'manjše od',
  'adm.auto.op.not_contains': 'ne vsebuje',
  'adm.auto.op.not_in': 'ni v',
  'adm.auto.op.starts_with': 'se začne z',
  'adm.auto.reorderFailed': 'Spreminjanje vrstnega reda ni uspelo',
  'adm.auto.saveFailed': 'Shranjevanje ni uspelo',
  'adm.auto.stopProcessing': 'Ustavi obdelavo naslednjih pravil',
  'adm.auto.title': 'Pravila avtomatizacije',
  'adm.auto.toggleFailed': 'Preklop ni uspel',
  'adm.auto.trigger': 'Sprožilec *',
  'adm.auto.trigger.ticket_creation': 'Ustvarjanje zahtevka',
  'adm.auto.trigger.ticket_update': 'Posodobitev zahtevka',
  'adm.auto.trigger.time_trigger': 'Na podlagi časa',
  'adm.auto.triggerCol': 'Sprožilec',
  'adm.auto.valuePlaceholder': 'Vrednost',
  'adm.auto.yes': 'Da',
  'adm.close': 'Zapri',
  'adm.deleting': 'Brisanje ...',
  'adm.description': 'Opis',
  'adm.descriptionLabel': 'Opis',
  'adm.edit': 'Uredi',
  'adm.email.addChannel': 'Dodaj kanal',
  'adm.email.addTitle': 'Dodaj e-poštni kanal',
  'adm.email.colEmail': 'E-pošta',
  'adm.email.colReplyTo': 'Odgovor na',
  'adm.email.colSmtp': 'SMTP',
  'adm.email.confirmDesc': 'Ta kanal ne bo več na voljo za pošto podpore.',
  'adm.email.confirmLabel': 'Izbriši kanal',
  'adm.email.confirmTitle': 'Izbrišete e-poštni kanal?',
  'adm.email.countMany': 'E-poštnih kanalov: {count}',
  'adm.email.countOne': '{count} e-poštni kanal',
  'adm.email.create': 'Ustvari',
  'adm.email.createFirst': 'Dodajte svoj prvi e-poštni kanal',
  'adm.email.createFirstDesc': 'Z gumbom Dodaj kanal povežite naslov podpore, da odgovori pridejo v ta center.',
  'adm.email.default': 'Privzeto',
  'adm.email.defaultChannel': 'Privzeti kanal',
  'adm.email.deleteFailed': 'Brisanje ni uspelo',
  'adm.email.description': 'Upravljajte dohodne/odhodne e-poštne naslove, konfiguracijo SMTP in nastavitve naslova za odgovor.',
  'adm.email.editTitle': 'Uredi e-poštni kanal',
  'adm.email.emailAddress': 'E-poštni naslov *',
  'adm.email.loadFailed': 'E-poštnih konfiguracij ni bilo mogoče naložiti',
  'adm.email.outbound': 'Odhodni SMTP',
  'adm.email.replyTo': 'Naslov za odgovor',
  'adm.email.replyToPh': '(privzeto e-poštni naslov)',
  'adm.email.saveFailed': 'Shranjevanje ni uspelo',
  'adm.email.sesGlobal': 'SES (globalno)',
  'adm.email.smtpHost': 'Gostitelj SMTP',
  'adm.email.smtpHostPh': 'npr. email-smtp.eu-central-1.amazonaws.com',
  'adm.email.smtpPassword': 'Geslo SMTP',
  'adm.email.smtpPort': 'Vrata SMTP',
  'adm.email.smtpUser': 'Uporabnik SMTP',
  'adm.email.title': 'E-poštni kanali',
  'adm.groups.aboutBody': 'Člani določajo, kateri agenti privzeto vidijo zahtevke te skupine. Delovni čas določa časovni potek SLA za sem usmerjene zahtevke, kontakt za eskalacijo pa je poleg odgovorne osebe obveščen, ko zahtevek krši SLA.',
  'adm.groups.aboutTitle': 'O tej skupini',
  'adm.groups.accountDefault': 'Privzeto za račun',
  'adm.groups.activeAgentMany': 'Aktivnih agentov: {count}',
  'adm.groups.activeAgentOne': '{count} aktivni agent',
  'adm.groups.activeAgents': 'Aktivni agenti',
  'adm.groups.addMember': 'Dodaj člana',
  'adm.groups.assignment': 'Dodeljevanje',
  'adm.groups.autoAssign': 'Samodejno dodeljevanje',
  'adm.groups.autoAssignNote': 'Dodeljevanje zahtevkov je v tem izdelku vedno ročno – ni krožnega ali na obremenitvi temelječega usmerjanja. To stikalo tega ne spremeni.',
  'adm.groups.businessHours': 'Delovni čas',
  'adm.groups.colGroup': 'Skupina',
  'adm.groups.confirmDesc': 'Zahtevke in predloge, ki uporabljajo to skupino, je treba najprej dodeliti drugam.',
  'adm.groups.confirmLabel': 'Izbriši skupino',
  'adm.groups.confirmTitle': 'Izbrišete „{name}“?',
  'adm.groups.createFirst': 'Ustvarite svojo prvo skupino',
  'adm.groups.defaultHours': 'Privzeti delovni čas',
  'adm.groups.editAria': 'Uredi {name}',
  'adm.groups.editGroup': 'Uredi skupino',
  'adm.groups.escalateHelp': 'Doda se kot prejemnik obvestila, ko zahtevek v tej skupini krši SLA.',
  'adm.groups.escalateTo': 'Eskaliraj na',
  'adm.groups.escalatesTo': 'Eskalira na',
  'adm.groups.escalatesToName': 'Eskalira na: {name}',
  'adm.groups.escalationBody': 'Ko zahtevek v tej skupini krši SLA, se kontakt za eskalacijo doda kot prejemnik obvestila poleg odgovorne osebe in članov skupine.',
  'adm.groups.escalationTitle': 'Kontakt za eskalacijo',
  'adm.groups.hoursHelp': 'Uporablja se za izračune SLA za zahtevke v tej skupini.',
  'adm.groups.manageAgents': 'Upravljaj agente',
  'adm.groups.manageHours': 'Upravljaj delovni čas',
  'adm.groups.manual': 'Ročno',
  'adm.groups.manualBody': 'Dodeljevanje je v tem izdelku ročno – ni krožnega ali na obremenitvi temelječega samodejnega dodeljevanja. Stikalo »Samodejno dodeljevanje« v skupini vpliva le na to, ali novi zahtevki v tej skupini privzeto ostanejo nedodeljeni ali preidejo na obstoječe pravilo usmerjanja; agenti zahtevke še vedno prevzemajo in predajajo sami.',
  'adm.groups.manualTitle': 'Ročno dodeljevanje',
  'adm.groups.memberMany': 'Članov: {count}',
  'adm.groups.memberOne': '{count} član',
  'adm.groups.members': 'Člani',
  'adm.groups.newGroup': 'Nova skupina',
  'adm.groups.noEscalation': 'Brez kontakta za eskalacijo',
  'adm.groups.noMatch': 'Temu iskanju ne ustreza nobena skupina',
  'adm.groups.noMembers': 'Članov še ni',
  'adm.groups.noMembersDesc': 'Zgoraj izberite aktivnega agenta in izberite Dodaj člana.',
  'adm.groups.remove': 'Odstrani',
  'adm.groups.routing': 'Usmerjanje',
  'adm.groups.routingMethod': 'Način usmerjanja',
  'adm.groups.saved': 'Skupina je shranjena.',
  'adm.groups.searchAria': 'Iskanje skupin',
  'adm.groups.searchPlaceholder': 'Išči po imenu',
  'adm.groups.selectActiveAgent': 'Izberite aktivnega agenta',
  'adm.groups.showing': 'Prikazano {start}–{end} od {total}',
  'adm.groups.subtitle': 'Skupine nadzorujejo usmerjanje in vidnost zahtevkov. Dodelite agente kot člane ter izberite urnik delovnega časa in kontakt za eskalacijo za vsako skupino.',
  'adm.groups.title': 'Skupine',
  'adm.groups.tryDifferent': 'Poskusite z drugim imenom skupine.',
  'adm.groups.unassigned': 'Ni dodeljeno',
  'adm.groups.useNew': 'Z gumbom Nova skupina usmerite zahtevke na skupino agentov.',
  'adm.groups.zero': '0 skupin',
  'adm.inactive': 'Neaktivno',
  'adm.jira.accepted': 'Povezava je sprejeta',
  'adm.jira.accountEmail': 'E-pošta računa Jira',
  'adm.jira.accountEmailLabel': 'E-pošta računa',
  'adm.jira.activeConn': 'Aktivna povezava',
  'adm.jira.addConnection': 'Dodaj povezavo',
  'adm.jira.addTitle': 'Dodaj povezavo Jira',
  'adm.jira.added': 'Povezava Jira je dodana',
  'adm.jira.apiToken': 'Žeton API',
  'adm.jira.clearSecret': 'Izbriši shranjeno skrivnost webhooka',
  'adm.jira.confirmDesc': 'S tem se odstranita shranjena povezava in povezave z zahtevki. Zadeve Jira se ne izbrišejo.',
  'adm.jira.confirmLabel': 'Izbriši povezavo',
  'adm.jira.confirmTitle': 'Izbrišete {name}?',
  'adm.jira.connName': 'Ime povezave',
  'adm.jira.connNamePh': 'Engineering Jira',
  'adm.jira.connectedAs': 'Povezano kot {name}',
  'adm.jira.connectionDesk': 'Pult povezav',
  'adm.jira.default': 'Privzeto',
  'adm.jira.defaultConn': 'Privzeta povezava',
  'adm.jira.defaultIssueType': 'Privzeta vrsta zadeve',
  'adm.jira.defaultProjectKey': 'Privzeti ključ projekta',
  'adm.jira.defaults': 'Privzete vrednosti',
  'adm.jira.description': 'Povežite spletna mesta Jira v lasti računa, da lahko agenti povezujejo zadeve in usklajujejo stanje zahtevkov.',
  'adm.jira.editTitle': 'Uredi povezavo Jira',
  'adm.jira.footer': 'Ustvarite webhook Jira s zgoraj prikazano končno točko, se naročite na dogodke posodobitve zadeve in uporabite isto skrivnost webhooka, kot je nastavljena tukaj.',
  'adm.jira.heading': 'Ohranite podporo in razvoj v isti zanki',
  'adm.jira.intro': 'Poverilnice so na strežniku shranjene šifrirano in se na ta zaslon nikoli ne vrnejo. Nastavite skrivnost webhooka, kadar naj Jira pošilja spremembe stanja nazaj v SuzukiDesk.',
  'adm.jira.no': 'Ne',
  'adm.jira.noConns': 'Povezav Jira še ni',
  'adm.jira.noConnsDesc': 'Dodajte povezavo, da bodo dejanja Jira na voljo v podrobnostih zahtevka.',
  'adm.jira.noProject': 'Brez projekta',
  'adm.jira.pasteToken': 'Prilepite žeton',
  'adm.jira.requestFailed': 'Zahteva Jira ni uspela. Poskusite znova.',
  'adm.jira.savedToast': 'Povezava Jira je shranjena',
  'adm.jira.secretConfigured': 'Skrivnost je nastavljena: {value}',
  'adm.jira.secretHint': 'Pri ustvarjanju webhooka Jira uporabite isto skrivnost.',
  'adm.jira.secretOptional': 'Neobvezno, 16+ znakov',
  'adm.jira.siteUrl': 'URL spletnega mesta Jira',
  'adm.jira.siteUrlHint': 'V URL ne vključite poverilnic.',
  'adm.jira.syncFromJira': 'Stanje Jira nazaj v zahtevek',
  'adm.jira.syncSnapshot': 'Posnetek povezane zadeve',
  'adm.jira.syncToJira': 'Stanje zahtevka v Jira',
  'adm.jira.testConnection': 'Preizkusi povezavo',
  'adm.jira.testFailed': 'Preizkus povezave ni uspel',
  'adm.jira.title': 'Integracija Jira',
  'adm.jira.tokenHintEdit': 'Pustite prazno, da obdržite trenutni žeton.',
  'adm.jira.tokenHintNew': 'Shranjeno šifrirano; ne bo več prikazano.',
  'adm.jira.tokenMissing': 'Žeton API manjka',
  'adm.jira.tokenStored': 'Žeton API je shranjen',
  'adm.jira.unchanged': '(nespremenjeno, če je prazno)',
  'adm.jira.verified': 'Povezava Jira je preverjena',
  'adm.jira.webhookEndpoint': 'Končna točka webhooka Jira',
  'adm.jira.webhookSecret': 'Skrivnost webhooka',
  'adm.jira.whatSyncs': 'Kaj se sinhronizira',
  'adm.jira.yes': 'Da',
  'adm.nameRequired': 'Ime *',
  'adm.nextPage': 'Naslednja stran',
  'adm.notif.aud.all': 'Skupno',
  'adm.notif.aud.customer': 'Stranka',
  'adm.notif.aud.internal': 'Interno',
  'adm.notif.audEmail': 'E-pošta: {audience}',
  'adm.notif.body': 'Telo',
  'adm.notif.description': 'Prilagodite vsako občinstvo obvestil, ne da bi stranke pošiljali v interni delovni prostor.',
  'adm.notif.discardDesc': 'Neshranjene spremembe te predloge obvestila bodo izgubljene, če zamenjate predlogo.',
  'adm.notif.discardLabel': 'Zavrzi spremembe',
  'adm.notif.discardTitle': 'Zavržete neshranjene spremembe?',
  'adm.notif.discarded': 'Neshranjene spremembe so zavržene.',
  'adm.notif.event.automation_notification': 'Obvestilo avtomatizacije',
  'adm.notif.event.group_member_added': 'Dodan v skupino',
  'adm.notif.event.mention': 'Omemba',
  'adm.notif.event.pending_input': 'Čaka na vnos',
  'adm.notif.event.sla_breach': 'Kršitev SLA',
  'adm.notif.event.sla_escalation': 'Eskalacija SLA',
  'adm.notif.event.sla_warning': 'Opozorilo SLA',
  'adm.notif.event.ticket_assigned': 'Zahtevek dodeljen',
  'adm.notif.event.ticket_created': 'Zahtevek ustvarjen',
  'adm.notif.event.ticket_first_response': 'Prvi odziv',
  'adm.notif.event.ticket_group_assigned': 'Zahtevek dodeljen skupini',
  'adm.notif.event.ticket_note': 'Zasebna opomba',
  'adm.notif.event.ticket_public_note': 'Javna opomba',
  'adm.notif.event.ticket_reply': 'Odgovor na zahtevek',
  'adm.notif.event.ticket_resolved': 'Zahtevek rešen',
  'adm.notif.events': 'Dogodki',
  'adm.notif.eventsHelp': 'Izberite dogodek in občinstvo prejemnikov.',
  'adm.notif.insertVar': 'Vstavi {variable}',
  'adm.notif.linkNoteAgent': 'Spremenljivka povezave, prilagojena občinstvu, {variable} odpre delovni prostor agenta za to e-pošto.',
  'adm.notif.linkNoteCustomer': 'Spremenljivka povezave, prilagojena občinstvu, {variable} odpre portal za stranke za to e-pošto.',
  'adm.notif.off': 'izklopljeno',
  'adm.notif.preview': 'Predogled',
  'adm.notif.previewNotice': 'Predogled je prikazan z vzorčnimi podatki.',
  'adm.notif.rendering': 'Upodabljanje …',
  'adm.notif.route.all': 'Uporablja povezavo do zahtevka, prilagojeno prejemniku, za občinstvo dostave.',
  'adm.notif.route.customer': 'Glavno dejanje odpre zahtevek v portalu za stranke.',
  'adm.notif.route.internal': 'Glavno dejanje odpre zahtevek v delovnem prostoru agenta.',
  'adm.notif.sampleOnlyAgent': 'Samo vzorčni podatki — glavno dejanje cilja na pot delovnega prostora agenta.',
  'adm.notif.sampleOnlyCustomer': 'Samo vzorčni podatki — glavno dejanje cilja na pot portala za stranke.',
  'adm.notif.saveChanges': 'Shrani spremembe',
  'adm.notif.saved': 'Predloga je shranjena.',
  'adm.notif.savedBtn': 'Shranjeno',
  'adm.notif.selectEvent': 'Izberite dogodek za urejanje njegove predloge',
  'adm.notif.selectEventDesc': 'Na levi izberite dogodek obvestila, da spremenite njegovo zadevo in telo.',
  'adm.notif.sendTest': 'Pošlji testno e-pošto',
  'adm.notif.sending': 'Pošiljanje …',
  'adm.notif.subject': 'Zadeva',
  'adm.notif.testQueued': 'Testna e-pošta je v čakalni vrsti za {email}.',
  'adm.notif.title': 'Predloge obvestil',
  'adm.notif.urlVarTitle': 'Spremenljivka povezave, prilagojena občinstvu',
  'adm.notif.useTemplate': 'Uporabi to predlogo za to občinstvo',
  'adm.notif.useTemplateHelp': 'Če izklopite, se uporabi varno nadomestno obvestilo.',
  'adm.notif.variables': 'Spremenljivke',
  'adm.notif.variablesHelp': 'Kliknite za dodajanje na konec telesa sporočila',
  'adm.pagination': 'Oštevilčenje strani',
  'adm.perm.cap.admin.label': 'Dostop do skrbniške konzole',
  'adm.perm.cap.assign.label': 'Dodelitev zahtevka',
  'adm.perm.cap.close.label': 'Zapiranje zahtevka',
  'adm.perm.cap.conversation_delete.label': 'Brisanje objavljenega odgovora ali opombe',
  'adm.perm.cap.conversation_edit.label': 'Urejanje objavljenega odgovora ali opombe',
  'adm.perm.cap.create.label': 'Ustvarjanje zahtevka',
  'adm.perm.cap.delete.label': 'Brisanje zahtevka',
  'adm.perm.cap.edit.label': 'Urejanje lastnosti zahtevka',
  'adm.perm.cap.export.label': 'Izvoz zahtevkov',
  'adm.perm.cap.field_admin.label': 'Polja zahtevka',
  'adm.perm.cap.form_admin.label': 'Obrazci zahtevkov',
  'adm.perm.cap.forward.label': 'Posredovanje zahtevka',
  'adm.perm.cap.jira_link.label': 'Povezovanje in upravljanje zadev Jira',
  'adm.perm.cap.kb.label': 'Dostop do zbirke znanja',
  'adm.perm.cap.manage_agents.label': 'Agenti',
  'adm.perm.cap.manage_api_keys.label': 'Ključi API',
  'adm.perm.cap.manage_automations.label': 'Avtomatizacije',
  'adm.perm.cap.manage_canned_responses.label': 'Pripravljeni odgovori',
  'adm.perm.cap.manage_email_config.label': 'E-pošta',
  'adm.perm.cap.manage_groups.label': 'Skupine',
  'adm.perm.cap.manage_jira.label': 'Integracija Jira',
  'adm.perm.cap.manage_kb.label': 'Zbirka znanja',
  'adm.perm.cap.manage_notification_templates.label': 'Predloge obvestil',
  'adm.perm.cap.manage_roles.label': 'Vloge',
  'adm.perm.cap.manage_tags.label': 'Oznake',
  'adm.perm.cap.note.label': 'Dodajanje ali urejanje zasebnih opomb',
  'adm.perm.cap.reassign.label': 'Ponovna dodelitev zahtevka, ki ga že ima nekdo drug',
  'adm.perm.cap.reopen.label': 'Ponovno odpiranje rešenega ali zaprtega zahtevka',
  'adm.perm.cap.reply.label': 'Javen odgovor stranki',
  'adm.perm.cap.report_access.label': 'Ogled poročil in nadzornih plošč',
  'adm.perm.cap.reports.label': 'Dostop do modula za poročanje',
  'adm.perm.cap.resolve.label': 'Reševanje zahtevka',
  'adm.perm.cap.settings_admin.label': 'Odpiranje razdelka Nastavitve (potrebno za prikaz elementa Nastavitve v navigaciji in njegove kazalne strani; dostop do posamezne strani spodaj se še vedno nadzira neodvisno)',
  'adm.perm.cap.sla_admin.label': 'Pravila SLA in delovni čas',
  'adm.perm.cap.sla_edit.desc': 'Ločeno od spodnjega dovoljenja Nastavitve > Pravila SLA — to zajema samo urejanje rokov pri posameznem zahtevku.',
  'adm.perm.cap.sla_edit.label': 'Ročni prepis rokov SLA zahtevka',
  'adm.perm.cap.tag.label': 'Upravljanje oznak zahtevkov',
  'adm.perm.cap.thread_start.label': 'Začetek zasebne niti pri vnosu pogovora',
  'adm.perm.cap.tickets.label': 'Dostop do delovnega prostora zahtevkov',
  'adm.perm.cap.view.label': 'Ogled zahtevkov v obsegu',
  'adm.perm.cat.administration.desc': 'Dostop do skrbniške konzole in njenih konfiguracijskih zaslonov.',
  'adm.perm.cat.administration.label': 'Administracija',
  'adm.perm.cat.knowledge.desc': 'Branje in uporaba vsebine znanja med obravnavo zahtevka.',
  'adm.perm.cat.knowledge.label': 'Zbirka znanja',
  'adm.perm.cat.reporting.desc': 'Operativno poročanje in nadzorne plošče.',
  'adm.perm.cat.reporting.label': 'Poročanje',
  'adm.perm.cat.settings-pages.desc': 'Dostop do vsakega zaslona Nastavitev podelite posebej. Nič ni vidno, dokler ni tukaj izrecno označeno.',
  'adm.perm.cat.settings-pages.label': 'Strani nastavitev',
  'adm.perm.cat.tickets.desc': 'Kaj lahko agent počne v delovnem prostoru zahtevkov.',
  'adm.perm.cat.tickets.label': 'Zahtevki',
  'adm.previousPage': 'Prejšnja stran',
  'adm.refresh': 'Osveži',
  'adm.roleType.administrator': 'Skrbnik',
  'adm.roleType.agent': 'Agent',
  'adm.roleType.collaborator': 'Sodelavec',
  'adm.roleType.customer': 'Stranka',
  'adm.roleType.super_admin': 'Super skrbnik',
  'adm.roleType.supervisor': 'Nadzornik',
  'adm.roles.activeHelp': 'Aktivno – neaktivnih vlog ni mogoče dodeliti agentom',
  'adm.roles.agentCan': 'Agent lahko',
  'adm.roles.agentType': 'Vrsta agenta',
  'adm.roles.agentsAssignedNote': 'Agentom se ta vloga dodeli na zaslonu Agenti.',
  'adm.roles.agentsCount': 'Agenti: {count}',
  'adm.roles.agentsLabel': 'Agenti',
  'adm.roles.agentsManage': 'Agenti: {count} – upravljaj',
  'adm.roles.builtIn': '(Vgrajena)',
  'adm.roles.builtInNote': 'To je vgrajena vloga. Preimenujete in deaktivirate jo lahko, ne morete pa je izbrisati.',
  'adm.roles.builtInTitle': 'Vgrajena vloga: jo je mogoče urejati in deaktivirati, ni pa je mogoče izbrisati',
  'adm.roles.categoriesAria': 'Kategorije dovoljenj',
  'adm.roles.confirmDesc': 'Agentom s to vlogo je treba dodeliti drugo vlogo, preden jo je mogoče odstraniti.',
  'adm.roles.confirmLabel': 'Izbriši vlogo',
  'adm.roles.createFirst': 'Ustvarite svojo prvo vlogo',
  'adm.roles.createFirstDesc': 'Z gumbom Nova vloga določite zmožnosti, ki naj jih agenti dobijo.',
  'adm.roles.editRole': 'Uredi vlogo',
  'adm.roles.granted': 'Dodeljenih: {count}',
  'adm.roles.heading': 'Vloge agentov',
  'adm.roles.inactive': 'Neaktivno',
  'adm.roles.newRole': 'Nova vloga',
  'adm.roles.noAgent': 'Brez agenta',
  'adm.roles.notEnforced': '(še ni uveljavljeno)',
  'adm.roles.notEnforcedTitle': 'Shranjeno v vlogi, a med izvajanjem še nikjer ni omejeno',
  'adm.roles.permissions': 'Dovoljenja',
  'adm.roles.saved': 'Vloga je shranjena.',
  'adm.roles.scopeBody': 'Zmožnosti se združujejo z obsegom na ravni vrstic (vse / skupina / dodeljeno / lastno), zato agent vedno deluje samo na zahtevkih, ki jih že vidi.',
  'adm.roles.scopeTitle': 'Obseg še vedno velja',
  'adm.roles.scrollTo': 'Pomakni na',
  'adm.roles.status': 'Stanje',
  'adm.roles.subtitle': 'Zagotovite in omejite podrobne ravni dostopa in privilegijev za agente.',
  'adm.roles.title': 'Vloge',
  'adm.roles.typeLocked': 'Vrste agenta po shranjevanju vloge ni mogoče spremeniti.',
  'adm.roles.understandingBody1': 'Vloge določajo, kaj lahko agent počne. Ustvarite vlogo, označite zmožnosti, ki naj jih podeli, nato jo na zaslonu Agenti dodelite agentom.',
  'adm.roles.understandingBody2': 'Vgrajene vloge je mogoče preimenovati in deaktivirati, nikoli pa izbrisati. Vloge, ki ima še dodeljene agente, prav tako ni mogoče izbrisati, zato najprej premaknite te agente.',
  'adm.roles.understandingTitle': 'Razumevanje vlog',
  'adm.saveChanges': 'Shrani spremembe',
  'adm.settings.add': 'Dodaj: {name}',
  'adm.settings.back': 'Nazaj na nastavitve',
  'adm.settings.cannedDesc': 'Odgovori računa, ki so vam na voljo med obravnavo zahtevka.',
  'adm.settings.cannedEmpty': 'Pripravljenih odgovorov še ni',
  'adm.settings.cannedEmptyDesc': 'Prosite skrbnika, naj doda skupne odgovore, ki jih lahko vaša ekipa ponovno uporabi pri zahtevku.',
  'adm.settings.cannedTitle': 'Pripravljeni odgovori',
  'adm.settings.col.autoAssign': 'Samodejna dodelitev',
  'adm.settings.col.color': 'Barva',
  'adm.settings.col.content': 'Vsebina',
  'adm.settings.col.createdAt': 'Ustvarjeno',
  'adm.settings.col.description': 'Opis',
  'adm.settings.col.email': 'E-pošta',
  'adm.settings.col.expiresAt': 'Poteče',
  'adm.settings.col.fieldType': 'Vrsta polja',
  'adm.settings.col.firstName': 'Ime',
  'adm.settings.col.folderId': 'ID mape',
  'adm.settings.col.hitCount': 'Število zadetkov',
  'adm.settings.col.holidays': 'Prazniki',
  'adm.settings.col.host': 'Gostitelj',
  'adm.settings.col.hours': 'Ure',
  'adm.settings.col.id': 'ID',
  'adm.settings.col.isActive': 'Aktivno',
  'adm.settings.col.isBuiltIn': 'Vgrajeno',
  'adm.settings.col.isDefault': 'Privzeto',
  'adm.settings.col.isRequired': 'Obvezno',
  'adm.settings.col.isShared': 'Skupno',
  'adm.settings.col.isSystem': 'Sistemsko',
  'adm.settings.col.key': 'Ključ',
  'adm.settings.col.label': 'Oznaka',
  'adm.settings.col.language': 'Jezik',
  'adm.settings.col.lastName': 'Priimek',
  'adm.settings.col.lastUsedAt': 'Nazadnje uporabljeno',
  'adm.settings.col.name': 'Ime',
  'adm.settings.col.options': 'Možnosti',
  'adm.settings.col.phone': 'Telefon',
  'adm.settings.col.port': 'Vrata',
  'adm.settings.col.position': 'Položaj',
  'adm.settings.col.prefix': 'Predpona',
  'adm.settings.col.priority': 'Prioriteta',
  'adm.settings.col.required': 'Obvezno',
  'adm.settings.col.role': 'Vloga',
  'adm.settings.col.roleId': 'ID vloge',
  'adm.settings.col.scopes': 'Obsegi',
  'adm.settings.col.slug': 'Slug',
  'adm.settings.col.status': 'Stanje',
  'adm.settings.col.stopProcessing': 'Ustavi obdelavo',
  'adm.settings.col.timezone': 'Časovni pas',
  'adm.settings.col.title': 'Naslov',
  'adm.settings.col.trigger': 'Sprožilec',
  'adm.settings.col.type': 'Vrsta',
  'adm.settings.col.updatedAt': 'Posodobljeno',
  'adm.settings.col.usageCount': 'Število uporab',
  'adm.settings.col.username': 'Uporabniško ime',
  'adm.settings.confirmDesc': 'Tega ni mogoče razveljaviti.',
  'adm.settings.confirmTitle': 'Izbrišete {name}?',
  'adm.settings.count': '{title}: {count}',
  'adm.settings.create': 'Ustvari',
  'adm.settings.empty': '{title} še ni',
  'adm.settings.emptyAdd': 'Z zgornjim obrazcem dodajte svoj prvi vnos ({name}).',
  'adm.settings.emptyOther': 'Vnosi se bodo prikazali tukaj, ko bodo konfigurirani.',
  'adm.settings.homeDesc': 'Konfigurirajte uporabnike, delovne tokove zahtevkov, ravni storitev in integracije.',
  'adm.settings.manage': 'Upravljanje: {title}.',
  'adm.settings.noPages': 'Strani nastavitev niso na voljo',
  'adm.settings.noPagesDesc': 'Prosite super skrbnika, naj vam omogoči dostop do strani nastavitev, ki jih potrebujete.',
  'adm.settings.notFound': 'Strani nastavitev ni mogoče najti',
  'adm.settings.notFoundDesc': 'Za nadaljevanje izberite področje nastavitev.',
  'adm.settings.res.agents.field.email': 'E-pošta',
  'adm.settings.res.agents.field.firstName': 'Ime',
  'adm.settings.res.agents.field.lastName': 'Priimek',
  'adm.settings.res.agents.field.password': 'Začasno geslo',
  'adm.settings.res.agents.field.roleId': 'ID vloge',
  'adm.settings.res.agents.one': 'agent',
  'adm.settings.res.agents.title': 'Agenti',
  'adm.settings.res.api-keys.field.name': 'Ime ključa',
  'adm.settings.res.api-keys.one': 'ključ API',
  'adm.settings.res.api-keys.title': 'Ključi API',
  'adm.settings.res.automations.field.description': 'Opis',
  'adm.settings.res.automations.field.name': 'Ime',
  'adm.settings.res.automations.one': 'avtomatizacija',
  'adm.settings.res.automations.title': 'Avtomatizacije',
  'adm.settings.res.business-hours.field.name': 'Ime',
  'adm.settings.res.business-hours.field.timezone': 'Časovni pas',
  'adm.settings.res.business-hours.one': 'vnos delovnega časa',
  'adm.settings.res.business-hours.title': 'Delovni čas',
  'adm.settings.res.canned-responses.field.content': 'Vsebina odgovora',
  'adm.settings.res.canned-responses.field.title': 'Naslov',
  'adm.settings.res.canned-responses.one': 'pripravljen odgovor',
  'adm.settings.res.canned-responses.title': 'Pripravljeni odgovori',
  'adm.settings.res.email.field.host': 'Gostitelj SMTP',
  'adm.settings.res.email.field.name': 'Ime',
  'adm.settings.res.email.field.port': 'Vrata SMTP',
  'adm.settings.res.email.field.username': 'Uporabniško ime',
  'adm.settings.res.email.one': 'e-poštna konfiguracija',
  'adm.settings.res.email.title': 'E-poštna konfiguracija',
  'adm.settings.res.fields.one': 'polje zahtevka',
  'adm.settings.res.fields.title': 'Polja zahtevka',
  'adm.settings.res.forms.field.label': 'Prikazana oznaka',
  'adm.settings.res.forms.field.name': 'Ime polja',
  'adm.settings.res.forms.field.type': 'Vrsta polja',
  'adm.settings.res.forms.one': 'obrazec ali polje po meri',
  'adm.settings.res.forms.title': 'Obrazci in polja po meri',
  'adm.settings.res.groups.field.description': 'Opis',
  'adm.settings.res.groups.field.name': 'Ime',
  'adm.settings.res.groups.one': 'skupina',
  'adm.settings.res.groups.title': 'Skupine',
  'adm.settings.res.jira.one': 'integracija Jira',
  'adm.settings.res.jira.title': 'Integracija Jira',
  'adm.settings.res.kb.field.content': 'Vsebina članka',
  'adm.settings.res.kb.field.folderId': 'ID mape',
  'adm.settings.res.kb.field.title': 'Naslov članka',
  'adm.settings.res.kb.one': 'članek zbirke znanja',
  'adm.settings.res.kb.title': 'Administracija zbirke znanja',
  'adm.settings.res.notification-templates.one': 'predloga obvestila',
  'adm.settings.res.notification-templates.title': 'Predloge obvestil',
  'adm.settings.res.roles.field.description': 'Opis',
  'adm.settings.res.roles.field.name': 'Ime',
  'adm.settings.res.roles.field.type': 'Vrsta vloge',
  'adm.settings.res.roles.one': 'vloga',
  'adm.settings.res.roles.title': 'Vloge',
  'adm.settings.res.sla.field.description': 'Opis',
  'adm.settings.res.sla.field.name': 'Ime',
  'adm.settings.res.sla.one': 'pravilo SLA',
  'adm.settings.res.sla.title': 'Pravila SLA',
  'adm.settings.res.tags.field.name': 'Ime',
  'adm.settings.res.tags.one': 'oznaka',
  'adm.settings.res.tags.title': 'Oznake',
  'adm.settings.title': 'Nastavitve',
  'adm.status': 'Stanje',

  'sla.edit': 'Uredi',
  'sla.active': 'Aktivno',
  'sla.inactive': 'Neaktivno',
  'sla.default': 'Privzeto',
  'sla.yes': 'Da',
  'sla.no': 'Ne',
  'sla.description': 'Opis',
  'sla.status': 'Stanje',
  'sla.notConfigured': 'Ni konfigurirano',
  'sla.minutesValue': '{value} min',
  'sla.invalidServerValue': 'Neveljavna vrednost strežnika',
  'sla.statusSemantics.title': 'Pomen stanj zahtevka',
  'sla.statusSemantics.description': 'Vsako aktivno stanje ima izrecno pogodbo SLA. Stanje, ki zaustavi SLA, in stanje, ki SLA ustavi, se medsebojno izključujeta.',
  'sla.statusSemantics.conflict': 'Stanje ne more hkrati zaustaviti SLA in ustaviti SLA.',
  'sla.statusSemantics.emptyTitle': 'Ni definicij stanj',
  'sla.statusSemantics.emptyDescription': 'Definicije stanj se bodo prikazale tukaj, ko bodo konfigurirane za ta račun.',
  'sla.statusSemantics.colPauses': 'Zaustavi SLA',
  'sla.statusSemantics.colStops': 'Ustavi SLA',
  'sla.statusSemantics.pausesAria': '{label} zaustavi SLA',
  'sla.statusSemantics.stopsAria': '{label} ustavi SLA',
  'sla.preview.title': 'Predogled zahtevka samo za branje',
  'sla.preview.description': 'Zaženite isti ocenjevalnik v obsegu računa, ki ga uporabljajo živi cikli SLA. Ta predogled nikoli ne zapiše pravila ali zahtevka.',
  'sla.preview.priority': 'Prioriteta',
  'sla.preview.group': 'Skupina',
  'sla.preview.anyGroup': 'Katera koli skupina',
  'sla.preview.company': 'Podjetje',
  'sla.preview.anyCompany': 'Katero koli podjetje',
  'sla.preview.source': 'Vir',
  'sla.preview.anySource': 'Kateri koli vir',
  'sla.preview.ticketType': 'Vrsta zahtevka',
  'sla.preview.anyTicketType': 'Katera koli vrsta zahtevka',
  'sla.preview.representativeStart': 'Reprezentativni začetek',
  'sla.preview.calculating': 'Izračunavanje …',
  'sla.preview.run': 'Zaženi predogled',
  'sla.preview.configAttention': 'Konfiguracija zahteva pozornost',
  'sla.preview.selectedPolicy': 'Izbrano pravilo',
  'sla.preview.noPolicy': 'Brez pravila',
  'sla.preview.evaluationOrder': 'Vrstni red ocenjevanja',
  'sla.preview.firstMatching': 'Prvo ujemajoče se pravilo',
  'sla.preview.calculationMode': 'Način izračuna',
  'sla.preview.modeBusinessHours': 'Delovni čas',
  'sla.preview.modeBusinessHoursNamed': 'Delovni čas · {name}',
  'sla.preview.mode247': 'Pretekli čas 24/7',
  'sla.preview.modeNone': 'Ni izračunano',
  'sla.preview.thresholds': 'Neodvisni pragovi',
  'sla.preview.colMetric': 'Metrika',
  'sla.preview.colTarget': 'Cilj',
  'sla.preview.colWarning': 'Opozorilo',
  'sla.preview.colDue': 'Rok / kršitev',
  'sla.preview.colEscalation': 'Eskalacija',
  'sla.preview.colState': 'Stanje',
  'sla.preview.metricFirstResponse': 'Prvi odziv',
  'sla.preview.metricResolution': 'Rešitev',
  'sla.preview.trace': 'Sled ocenjevanja pravil',
  'sla.preview.selected': 'Izbrano',
  'sla.preview.matchedAfterSelection': 'Ujemanje po izbiri',
  'sla.preview.skipped': 'Preskočeno',
  'sla.preview.showTrace': 'Pokaži sled izračuna',
  'sla.state.not_configured': 'ni konfigurirano',
  'sla.state.running': 'teče',
  'sla.state.paused': 'zaustavljeno',
  'sla.state.warning': 'opozorilo',
  'sla.state.breached': 'kršeno',
  'sla.state.met': 'izpolnjeno',
  'sla.state.escalated': 'eskalirano',
  'sla.state.pending': 'v čakanju',
  'sla.state.stopped': 'ustavljeno',
  'sla.state.on_track': 'po načrtu',
  'sla.state.at_risk': 'ogroženo',
  'sla.list.subtitle': 'Nastavite cilje prvega odziva in rešitve za posamezno prioriteto. Pravila se ocenjujejo od zgoraj navzdol — zmaga prvo, katerega pogoji se ujemajo z zahtevkom.',
  'sla.list.newPolicy': 'Novo pravilo',
  'sla.list.emptyTitle': 'Ustvarite svoje prvo pravilo SLA',
  'sla.list.emptyDescription': 'Z gumbom Novo pravilo nastavite cilje prvega odziva in rešitve za posamezno prioriteto.',
  'sla.list.moveUp': 'Premakni navzgor',
  'sla.list.moveDown': 'Premakni navzdol',
  'sla.list.frShort': 'PO: {value}',
  'sla.list.resolveShort': 'Rešitev: {value}',
  'sla.list.escalateShort': 'Eskalacija: +{value}',
  'sla.list.deactivate': 'Deaktiviraj',
  'sla.list.activate': 'Aktiviraj',
  'sla.list.setDefault': 'Nastavi kot privzeto',
  'sla.list.duplicate': 'Podvoji',
  'sla.list.deleteTitle': 'Izbrišete „{name}“?',
  'sla.list.deleteDescription': 'Zahtevki, ki se ujemajo s tem pravilom, bodo uporabili naslednje razpoložljivo pravilo SLA.',
  'sla.list.deleteConfirm': 'Izbriši pravilo',
  'sla.conditions.groups': 'Skupine: {count}',
  'sla.conditions.companies': 'Podjetja: {count}',
  'sla.conditions.sources': 'viri: {list}',
  'sla.conditions.ticketTypes': 'Vrste zahtevkov: {count}',
  'sla.conditions.anyOf': 'kateri koli od',
  'sla.conditions.allOf': 'vsi od',
  'sla.conditions.summary': 'Pogoji ({mode}): {parts}',
  'sla.edit.newTitle': 'Novo pravilo SLA',
  'sla.edit.editTitle': 'Uredi pravilo SLA',
  'sla.edit.saved': 'Pravilo SLA je shranjeno.',
  'sla.edit.name': 'Ime',
  'sla.edit.appliesToPriority': 'Velja za prioriteto',
  'sla.edit.evaluationOrder': 'Vrstni red ocenjevanja',
  'sla.edit.evaluationOrderHint': 'Nižji položaji se za ta račun ocenjujejo prej.',
  'sla.edit.defaultPolicy': 'Privzeto pravilo',
  'sla.edit.useAsDefault': 'Uporabi kot privzeto, ko se nobeno drugo pravilo ne ujema',
  'sla.edit.targets': 'Cilji SLA',
  'sla.edit.firstResponse': 'Prvi odziv',
  'sla.edit.resolution': 'Rešitev',
  'sla.edit.autoAt75': 'Samodejno pri 75 %',
  'sla.edit.enabledAfter': 'Omogočeno po {value}',
  'sla.edit.clearEscalation': 'Izrecno izbriši cilj eskalacije',
  'sla.edit.clearEscalationHint': 'Pošlje null; če to ni označeno, se polje izpusti in shranjena vrednost ostane.',
  'sla.edit.firstResponseMinutes': 'Prvi odziv (minute)',
  'sla.edit.resolutionMinutes': 'Rešitev (minute)',
  'sla.edit.escalateAfter': 'Eskaliraj po (minutah po roku za rešitev)',
  'sla.edit.notSet': 'Ni nastavljeno',
  'sla.edit.remindersNote': 'Opomniki se samodejno sprožijo pri 75 % oken prvega odziva in rešitve. Eskalacija obvesti agenta za eskalacijo skupine zahtevka (nastavljenega v skupini), ko je cilj rešitve presežen za konfigurirano število minut.',
  'sla.edit.conditions': 'Pogoji',
  'sla.edit.conditionsHint': 'Pustite skupino neoznačeno, da se ujemajo vse vrednosti',
  'sla.edit.matchMode': 'Način ujemanja:',
  'sla.edit.matchAll': 'Ujemanje VSEH pogojev',
  'sla.edit.matchAny': 'Ujemanje KATEREGA KOLI pogoja',
  'sla.edit.groups': 'Skupine',
  'sla.edit.companies': 'Podjetja',
  'sla.edit.sources': 'Viri',
  'sla.edit.ticketTypes': 'Vrste zahtevkov',
  'sla.bh.subtitle': 'Določite tedenski urnik in koledar praznikov, ki ju pravila SLA uporabljajo za izračun rokov.',
  'sla.bh.newCalendar': 'Nov koledar',
  'sla.bh.emptyTitle': 'Ustvarite svoj prvi koledar delovnega časa',
  'sla.bh.emptyDescription': 'Z gumbom Nov koledar določite tedenski urnik, glede na katerega pravila SLA štejejo čas.',
  'sla.bh.accountDefault': 'Privzeto za račun',
  'sla.bh.closedEveryDay': 'Zaprto vsak dan',
  'sla.bh.openEveryDay': 'Odprto vsak dan',
  'sla.bh.openDaysOne': 'Odprto 1 dan/teden',
  'sla.bh.openDaysMany': 'Odprto dni na teden: {count}',
  'sla.bh.holidayOne': '1 praznik',
  'sla.bh.holidayMany': 'Praznikov: {count}',
  'sla.bh.deleteTitle': 'Izbrišete „{name}“?',
  'sla.bh.deleteDescription': 'Pravila SLA in skupine, ki uporabljajo ta urnik, bodo preklopila na privzeto vrednost računa.',
  'sla.bh.deleteConfirm': 'Izbriši urnik',
  'sla.bh.newTitle': 'Nov koledar delovnega časa',
  'sla.bh.editTitle': 'Uredi delovni čas',
  'sla.bh.saved': 'Delovni čas je shranjen.',
  'sla.bh.timezone': 'Časovni pas',
  'sla.bh.defaultCalendar': 'Privzeti koledar',
  'sla.bh.useAsDefault': 'Uporabi za pravila SLA in skupine, ki ne določajo lastnega koledarja',
  'sla.bh.weeklySchedule': 'Tedenski urnik',
  'sla.bh.colDay': 'Dan',
  'sla.bh.colOpen': 'Odprto',
  'sla.bh.colStart': 'Začetek',
  'sla.bh.colEnd': 'Konec',
  'sla.bh.dayOpenAria': '{day} odprto',
  'sla.bh.dayStartAria': '{day} – začetni čas',
  'sla.bh.dayEndAria': '{day} – končni čas',
  'sla.bh.holidayCalendar': 'Koledar praznikov',
  'sla.bh.saveFirst': 'Najprej shranite ta koledar, nato dodajte praznike.',
  'sla.bh.holidayName': 'Ime praznika',
  'sla.bh.date': 'Datum',
  'sla.bh.addHoliday': 'Dodaj praznik',
  'sla.bh.noHolidays': 'Praznikov še ni',
  'sla.bh.noHolidaysHint': 'Zgoraj dodajte praznik z datumom, da ga izključite iz izračunov SLA.',
  'sla.bh.remove': 'Odstrani',
  'sla.day.monday': 'ponedeljek',
  'sla.day.tuesday': 'torek',
  'sla.day.wednesday': 'sreda',
  'sla.day.thursday': 'četrtek',
  'sla.day.friday': 'petek',
  'sla.day.saturday': 'sobota',
  'sla.day.sunday': 'nedelja',

  'set.ftype.single_line_text': 'Enovrstično besedilo',
  'set.ftype.multi_line_text': 'Večvrstično besedilo',
  'set.ftype.dropdown': 'Spustni seznam',
  'set.ftype.checkbox': 'Potrditveno polje',
  'set.ftype.radio': 'Izbirni gumb',
  'set.ftype.multiselect': 'Večkratna izbira',
  'set.ftype.lookup': 'Iskalna povezava',
  'set.ftype.dependent': 'Odvisno polje',
  'set.ftype.date': 'Datum',
  'set.ftype.number': 'Število',
  'set.ftype.decimal': 'Decimalno število',
  'set.ftype.desc.lookup': 'Izberite zapis iz sistemskega vira.',
  'set.ftype.desc.single_line_text': 'Kratka besedilna vrednost.',
  'set.ftype.desc.multi_line_text': 'Dolga besedilna vrednost.',
  'set.ftype.desc.checkbox': 'Vrednost da ali ne.',
  'set.ftype.desc.dropdown': 'Izberite eno normalizirano možnost.',
  'set.ftype.desc.dependent': 'Možnosti so odvisne od nadrejenega polja.',
  'set.ftype.desc.date': 'Vrednost koledarskega datuma.',
  'set.ftype.desc.number': 'Celoštevilska vrednost.',
  'set.ftype.desc.decimal': 'Decimalna vrednost.',
  'set.src.STATIC': 'Statične možnosti',
  'set.src.AGENTS': 'Agenti',
  'set.src.USERS': 'Uporabniki / stranke',
  'set.src.GROUPS': 'Skupine',
  'set.src.ROLE': 'Vloge',
  'set.src.COUNTRIES': 'Države',
  'set.src.CUSTOM': 'Spustni seznam po meri',
  'set.settings': 'Nastavitve',
  'set.ticketFields': 'Polja zahtevka',
  'set.ticketForms': 'Obrazci zahtevkov',
  'set.requestFailed': 'Zahteva ni uspela. Poskusite znova.',
  'set.refresh': 'Osveži',
  'set.saving': 'Shranjevanje …',
  'set.saveChanges': 'Shrani spremembe',
  'set.default': 'Privzeto',
  'set.published': 'Objavljeno',
  'set.draft': 'Osnutek',
  'set.publish': 'Objavi',
  'set.unpublish': 'Prekliči objavo',
  'set.deleteForm': 'Izbriši obrazec',
  'set.description': 'Opis',
  'set.relationshipSource': 'Vir povezave',
  'set.dependsOn': 'Odvisno od: {field}',
  'set.deleteFormTitle': 'Izbrišete „{name}“?',
  'set.deleteFormDescription': 'Ta obrazec zahtevka in njegova konfiguracija bosta trajno izbrisana.',
  'set.formIdRequired': 'ID obrazca je obvezen.',
  'set.formNotFound': 'Obrazca zahtevka ni mogoče najti.',
  'set.tf.removeOption': 'Odstrani {label}',
  'set.tf.noOptions': 'Možnosti še niso določene.',
  'set.tf.addOptionPlaceholder': 'Dodaj možnost ...',
  'set.tf.add': 'Dodaj',
  'set.tf.dependsOnField': 'Odvisno od polja',
  'set.tf.selectParent': '— Izberite nadrejeno polje —',
  'set.tf.parentHelp': 'Nadrejeno spustno polje, katerega izbrana vrednost določa razpoložljive možnosti tega polja.',
  'set.tf.optionMappings': 'Preslikave možnosti',
  'set.tf.savingParen': '(shranjevanje ...)',
  'set.tf.mappingsError': 'Preslikav ni bilo mogoče naložiti',
  'set.tf.archivedParen': ' (arhivirano)',
  'set.tf.mappedCount': 'Preslikanih: {count}',
  'set.tf.saveFirst': 'Najprej shranite polje, da konfigurirate preslikave možnosti.',
  'set.tf.newField': 'Novo: {type}',
  'set.tf.pageDescription': 'Upravljajte uvožene definicije polj, vidnost, pravila obveznosti in vrstni red, ki ga uporabljajo obrazci zahtevkov.',
  'set.tf.addField': 'Dodaj polje',
  'set.tf.addFieldHelp': 'Povlecite vrsto na seznam polj ali uporabite Dodaj.',
  'set.tf.addType': 'Dodaj: {type}',
  'set.tf.registry': 'Register polj',
  'set.tf.savingOrder': 'Shranjevanje vrstnega reda …',
  'set.tf.searchAria': 'Iskanje polj zahtevka',
  'set.tf.searchPlaceholder': 'Išči po imenu ali ključu ...',
  'set.tf.filterAria': 'Filtriraj po vrsti polja',
  'set.tf.allTypes': 'Vse vrste polj',
  'set.tf.emptyFirstTitle': 'Dodajte svoje prvo polje zahtevka',
  'set.tf.emptyFirstDesc': 'Povlecite vrsto polja iz palete ali uporabite Dodaj, da ga ustvarite.',
  'set.tf.emptyFilterTitle': 'Tem filtrom ne ustreza nobeno polje',
  'set.tf.emptyFilterDesc': 'Poskusite z drugim iskalnim izrazom ali razširite filter vrste polja.',
  'set.tf.archived': 'Arhivirano',
  'set.tf.dependent': 'Odvisno',
  'set.tf.customerVisible': 'Vidno strankam',
  'set.tf.internal': 'Interno',
  'set.tf.configuration': 'Konfiguracija polja',
  'set.tf.selectTitle': 'Izberite polje za konfiguracijo',
  'set.tf.selectDesc': 'Izberite polje iz registra, da uredite njegove oznake, pravila in vidnost.',
  'set.tf.externalId': 'Zunanji ID: {value}',
  'set.tf.sourceRenderer': 'Vir: {source} · Upodabljalnik: {renderer}',
  'set.tf.optionSource': 'Vir možnosti: {value}',
  'set.tf.dependsOnKey': 'Odvisno od: {value}',
  'set.tf.internalLabel': 'Interna oznaka',
  'set.tf.customerLabel': 'Oznaka za stranke',
  'set.tf.relationshipHelp': 'Določa, od kod se med izvajanjem pridobijo vrednosti iskanja.',
  'set.tf.validationVisibility': 'Preverjanje in vidnost',
  'set.tf.requiredAgents': 'Obvezno za agente',
  'set.tf.requiredCustomers': 'Obvezno za stranke',
  'set.tf.requiredClosure': 'Obvezno za zaprtje',
  'set.tf.displayedCustomers': 'Prikazano strankam',
  'set.tf.customersEdit': 'Stranke lahko urejajo',
  'set.tf.customersFilter': 'Stranke lahko filtrirajo',
  'set.tf.active': 'Aktivno',
  'set.tf.dropdownOptions': 'Možnosti spustnega seznama ({count})',
  'set.tf.archiveTitle': 'Arhivirate „{name}“?',
  'set.tf.archiveDesc': 'Polje bo postalo neaktivno in ne bo na voljo za nove zahtevke. Obstoječi podatki zahtevkov so ohranjeni.',
  'set.tf.archiveField': 'Arhiviraj polje',
  'set.tf.alreadyArchived': 'Že arhivirano',
  'set.tf.archivedNote': 'Arhivirana polja ostanejo na voljo za zgodovinske vrednosti.',
  'set.tfm.systemUser': 'Sistem',
  'set.tfm.untitled': 'Obrazec brez naslova',
  'set.tfm.pageDescription': 'Ustvarite ponovno uporabne obrazce in izberite, katera uvožena polja lahko uporabljajo agenti in stranke.',
  'set.tfm.newForm': 'Nov obrazec',
  'set.tfm.creating': 'Ustvarjanje …',
  'set.tfm.allForms': 'Vsi obrazci',
  'set.tfm.configuredOne': '{count} konfiguriran obrazec',
  'set.tfm.configuredMany': 'Konfiguriranih obrazcev: {count}',
  'set.tfm.filter': 'Filter',
  'set.tfm.searchAria': 'Iskanje obrazcev zahtevkov',
  'set.tfm.searchPlaceholder': 'Išči obrazce …',
  'set.tfm.status': 'Stanje',
  'set.tfm.allStatuses': 'Vsa stanja',
  'set.tfm.emptyFilterTitle': 'Tem filtrom ne ustreza noben obrazec',
  'set.tfm.emptyFilterDesc': 'Poskusite z drugim iskalnim izrazom ali razširite filter stanja.',
  'set.tfm.emptyFirstTitle': 'Ustvarite svoj prvi obrazec zahtevka',
  'set.tfm.emptyFirstDesc': 'Ustvarite obrazec, da začnete konfigurirati uvožena polja.',
  'set.tfm.createFirst': 'Ustvarite svoj prvi obrazec',
  'set.tfm.colName': 'Ime',
  'set.tfm.colCreatedAt': 'Ustvarjeno',
  'set.tfm.colUpdatedBy': 'Nazadnje posodobil(-a)',
  'set.tfm.colUpdatedAt': 'Nazadnje posodobljeno',
  'set.tfm.colPortals': 'Povezani portali',
  'set.tfm.colActions': 'Dejanja',
  'set.tfm.notConfigured': 'Ni konfigurirano',
  'set.tfm.actionsFor': 'Dejanja za {name}',
  'set.tfm.editForm': 'Uredi obrazec',
  'set.tb.section.default.title': 'Privzeta polja',
  'set.tb.section.default.desc': 'Osnovna polja delovnega toka podpore, uvožena iz izvornega sistema.',
  'set.tb.section.custom.title': 'Polja po meri',
  'set.tb.section.custom.desc': 'Dodatna polja, konfigurirana za vaš proces podpore.',
  'set.tb.section.nested.title': 'Gnezdena polja',
  'set.tb.section.nested.desc': 'Odvisna polja, katerih možnosti sledijo nadrejenemu polju.',
  'set.tb.discardTitle': 'Zavržete neshranjene spremembe?',
  'set.tb.discardDesc': 'Vaše spremembe tega obrazca zahtevka niso shranjene.',
  'set.tb.leave': 'Zapusti brez shranjevanja',
  'set.tb.nameRequired': 'Ime obrazca je obvezno.',
  'set.tb.saved': 'Obrazec je shranjen.',
  'set.tb.nowPublished': 'Obrazec je objavljen.',
  'set.tb.nowUnpublished': 'Objava obrazca je preklicana.',
  'set.tb.admin': 'Skrbnik',
  'set.tb.builder': 'Graditelj',
  'set.tb.titleAria': 'Naslov obrazca',
  'set.tb.defaultLocked': 'Privzeto / zaklenjeno',
  'set.tb.previewPortal': 'Predogled na portalu',
  'set.tb.configureTitle': 'Konfigurirajte polja, vključena v ta obrazec.',
  'set.tb.configureDesc': 'Spremembe se v bazo podatkov centra za podporo shranijo, ko izberete Shrani spremembe. Obvezna polja ostanejo omogočena.',
  'set.tb.formDetails': 'Podrobnosti obrazca',
  'set.tb.formDetailsHelp': 'Uporabite jasen opis, da skrbniki vedo, kdaj uporabiti ta obrazec.',
  'set.tb.descPlaceholder': 'Opišite, kdaj naj se ta obrazec uporablja …',
  'set.tb.importedFields': 'Uvožena polja',
  'set.tb.importedHelp': 'Povlecite za spremembo vrstnega reda polj. S stikalom polje vključite ali izključite iz tega obrazca.',
  'set.tb.noneInSection': 'V tem razdelku ni uvoženih polj.',
  'set.tb.dragReorder': 'Povlecite za spremembo vrstnega reda',
  'set.tb.required': 'Obvezno',
  'set.tb.nested': 'Gnezdeno',
  'set.tb.enableField': 'Omogoči: {label}',
  'set.tb.enabled': 'Omogočeno',
  'set.tb.disabled': 'Onemogočeno',
  'set.tb.emptyTitle': 'Polj za konfiguracijo še ni',
  'set.tb.emptyDesc': 'Uvozite polja zahtevka, da začnete graditi ta obrazec.',
  'set.tb.deleting': 'Brisanje …',
  'set.tp.loadError': 'Predogleda obrazca ni bilo mogoče naložiti.',
  'set.tp.preview': 'Predogled',
  'set.tp.customerPreview': 'Predogled za stranke',
  'set.tp.backToBuilder': 'Nazaj na graditelja',
  'set.tp.modeTitle': 'Način predogleda',
  'set.tp.modeDesc': 'To je predogled brez oddaje. Vsa omogočena polja so prikazana v shranjenem vrstnem redu obrazca.',
  'set.tp.emptyTitle': 'Nobeno polje še ni omogočeno',
  'set.tp.emptyDesc': 'Omogočite polja v graditelju obrazcev, da jih vidite v tem predogledu.',

  'por.error.generic': 'Zahteve ni bilo mogoče dokončati.',
  'por.error.requestNotFound': 'Zahtevka ni mogoče najti.',
  'por.error.formUnavailable': 'Obrazec zahtevka ni na voljo.',
  'por.error.articleNotFound': 'Članka ni mogoče najti.',
  'por.error.selectRating': 'Izberite oceno od 1 do 5.',
  'por.tab.all': 'Vse',
  'por.list.title': 'Moji zahtevki za podporo',
  'por.list.description': 'Spremljajte svoje zahtevke in odgovarjajte ekipi za podporo.',
  'por.list.newRequest': 'Nov zahtevek',
  'por.list.knowledgeBase': 'Zbirka znanja',
  'por.list.filterByStatus': 'Filtriraj zahtevke po stanju',
  'por.list.searchPlaceholder': 'Išči po zadevi …',
  'por.list.count': 'Zahtevkov: {count}',
  'por.list.countOne': '{count} zahtevek',
  'por.list.emptyFilteredTitle': 'Temu prikazu ne ustreza noben zahtevek',
  'por.list.emptyTitle': 'Zahtevkov še ni',
  'por.list.emptyFilteredDescription': 'Poskusite zavihek Vse ali drug iskalni izraz.',
  'por.list.emptyDescription': 'Oddajte zahtevek in ekipa za podporo ga bo prevzela.',
  'por.list.submitFirst': 'Oddajte svoj prvi zahtevek',
  'por.col.request': 'Zahtevek',
  'por.col.subject': 'Zadeva',
  'por.col.status': 'Stanje',
  'por.col.priority': 'Prioriteta',
  'por.col.created': 'Ustvarjeno',
  'por.detail.myRequests': 'Moji zahtevki',
  'por.detail.reopen': 'Ponovno odpri ta zahtevek',
  'por.detail.attachments': 'Priloge',
  'por.detail.download': 'Prenesi',
  'por.detail.conversation': 'Pogovor',
  'por.detail.noReplies': 'Odgovorov še ni',
  'por.detail.noRepliesHint': 'Spodaj dodajte odgovor in ekipa za podporo ga bo prevzela.',
  'por.detail.reply': 'Odgovor',
  'por.detail.replyPlaceholder': 'Napišite odgovor',
  'por.detail.sending': 'Pošiljanje …',
  'por.detail.sendReply': 'Pošlji odgovor',
  'por.file.sizeKb': '{size} KB',
  'por.file.remove': 'Odstrani {name}',
  'por.submit.newRequest': 'Nov zahtevek',
  'por.submit.defaultTitle': 'Oddajte zahtevek za podporo',
  'por.submit.intro': 'Izpolnite spodnja polja in oddajte zahtevek.',
  'por.submit.subjectRequired': 'Zadeva je obvezna',
  'por.submit.descriptionRequired': 'Opis je obvezen',
  'por.submit.attachments': 'Priloge',
  'por.submit.submitting': 'Oddajanje …',
  'por.submit.submit': 'Oddaj zahtevek',
  'por.kb.portal': 'Portal',
  'por.kb.title': 'Zbirka znanja',
  'por.kb.description': 'Poiščite odgovore, preden oddate zahtevek.',
  'por.kb.crumbRoot': 'KB',
  'por.kb.searchResults': 'Rezultati iskanja',
  'por.kb.searchPlaceholder': 'Išči članke',
  'por.kb.emptyTitle': 'Člankov še ni objavljenih',
  'por.kb.emptyDescription': 'Oddajte zahtevek in ekipa za podporo vam bo pomagala neposredno.',
  'por.kb.noFolders': 'Ni map',
  'por.kb.articles': 'Člankov: {count}',
  'por.kb.articlesOne': '{count} članek',
  'por.kb.noMatch': 'Za „{query}“ ni ustreznih člankov',
  'por.kb.folderEmpty': 'V tej mapi še ni člankov',
  'por.kb.noMatchHint': 'Poskusite s krajšim iskalnim izrazom ali pa oddajte zahtevek.',
  'por.kb.folderEmptyHint': 'Prebrskajte drugo mapo ali pa oddajte zahtevek.',
  'por.kb.submitRequest': 'Oddajte zahtevek',
  'por.kb.views': 'Ogledov: {count}',
  'por.kb.thanks': 'Hvala za vaše povratne informacije!',
  'por.kb.helpful': 'Vam je bilo to v pomoč?',
  'por.kb.yes': 'Da',
  'por.kb.no': 'Ne',
  'por.csat.thanksTitle': 'Hvala za vaše povratne informacije',
  'por.csat.thanksBody': 'Vaš odgovor je zabeležen.',
  'por.csat.title': 'Kako smo se odrezali?',
  'por.csat.request': 'Zahtevek št. {number}: {subject}',
  'por.csat.rating': 'Ocena',
  'por.csat.stars': 'Zvezdic: {count}',
  'por.csat.comment': 'Komentar',
  'por.csat.submit': 'Pošlji povratne informacije',
  'agents.tempPassword.title': 'Začasno geslo',
  'agents.tempPassword.help': 'Nastavite začasno geslo za tega agenta. Ob naslednji prijavi bo moral izbrati novo geslo. Vsaj 12 znakov.',
  'agents.tempPassword.button': 'Nastavi začasno geslo',
  'agents.tempPassword.saving': 'Nastavljanje …',
  'agents.tempPassword.error': 'Začasnega gesla ni mogoče nastaviti.',
  'ui.showPassword': 'Pokaži geslo',
  'ui.hidePassword': 'Skrij geslo',
  'dashboard.awaitingResolutionConfirmation': 'Čaka na potrditev rešitve',
  'dashboard.awaitingUserReply': 'Čaka na odgovor uporabnika',
  'dashboard.changeRequests': 'Zahtevki za spremembo',
  'agents.tempPassword.successEmailed': 'Začasno geslo je nastavljeno in poslano agentu po e-pošti.',
  'agents.tempPassword.successNotEmailed': 'Začasno geslo je nastavljeno, vendar e-pošte ni bilo mogoče poslati. Delite geslo z agentom prek varnega kanala.',
} as const;

export default sl;
